export const translationRu = {
  '<all users>': '<все пользователи>',
  '24 hours': '24 часа',
  '30 days': '30 дней',
  '7 days': '7 дней',
  Account: 'Аккаунт',
  'Accounting unit': 'Единица учета',
  'Accounting for battery replacement': 'Учет замены АКБ',
  'Access Rights': 'Права',
  'Access to document verification': 'Доступ к проверке документов',
  'Access to checking extended registration documents is allowed. After the time has expired, the password must be re-entered to reset the timer and continue testing.':
    'Доступ к проверке документов расширенной регистрации разрешен. По истечении времени для сброса таймера и продолжения проверки необходимо ввести пароль повторно.',
  'Around the clock': 'Круглосуточно',
  Acquirer: 'Эквайер',
  'Acquirer Id': 'Идентификатор Приобретателя',
  Acquirers: 'Эквайринг',
  Activation: 'Активация',
  'Activation conditions': 'Условия активации',
  Action: 'Действие',
  Actions: 'Действия',
  Analytics: 'Аналитика',
  Author: 'Автор',
  'Active order': 'В аренде',
  'Automatic debits': 'Автоматические списания',
  'Altitude above sea level': 'Высота над уровнем моря',
  Inactive: 'Неактивные',
  'Active trip': 'Активная поездка',
  'Active subscription': 'Активный абонемент',
  'Active subscriptions': 'Активные абонементы',
  'Activity time': 'Время активности',
  'Activity log': 'Журнал действий',
  'Activity level': 'Уровень активности',
  Activate: 'Активировать',
  Deactivate: 'Деактивировать',
  'Activate if necessary to specify the color of the object': 'Активируйте в случае необходимости указания цвета объекта',
  'Activate to provide access to the functionality of creating and editing rates.':
    'Активируйте, чтобы предоставить доступ к функционалу создания и редактирования тарифов',
  'Activate if you want the first rate in the list of available rates for the unit to be selected by default.':
    'Активируйте, если вы хотите, чтобы первый тариф в списке доступных тарифов объекта был выбран по умолчанию',
  'Active bank card': 'Активная банковская карта',
  'Mobile application and its version': 'Мобильное приложение и его версия',
  Add: 'Добавить',
  'Add more': 'Добавить ещё',
  'Add Geopoint': 'Добавить геоточку',
  'Add action': 'Добавить действие',
  'Add comment': 'Добавить комментарий',
  'Add condition': 'Добавить условие',
  'Ad cover': 'Обложка объявления',
  'Add document': 'Добавить документ',
  'Add geofence': 'Добавить геозону',
  'Add price plan': 'Добавить тариф',
  'Add language': 'Добавить язык',
  'Add point': 'Добавить точку',
  'Add image': 'Добавить фото',
  'Add video': 'Добавить видео',
  'Add part': 'Добавить часть',
  'Add event': 'Добавить событие',
  'Add translates': 'Добавить переводы',
  'Add translate': 'Добавить перевод',
  'Add to group': 'Добавить в группу',
  'Add working days': 'Добавить рабочие дни',
  'Add time period': 'Добавить период времени',
  Address: 'Адрес',
  'Additional Information': 'Дополнительная информация',
  'Additional information about the tariff, including information about the debiting of funds and conditions.':
    'Дополнительная информация о тарифе, включающая информацию о списании денежных средств и условий.',
  'Add the document content, including data substitution patterns.': 'Добавьте содержание документа, включая шаблоны подстановки данных.',
  Admin: 'Админ',
  Administrator: 'Администратор',
  Manager: 'Менеджер',
  'Admin login': 'Логин администратора',
  'Alarm retranslator': 'Ретранслятор тревог',
  'Are you sure?': 'Вы уверены?',
  'Arbitrary command': 'Произвольная команда',
  Retranslator: 'Ретранслятор',
  'Alarming notification': 'Тревожное уведомление',
  'Alarm notifications': 'Тревожные уведомления',
  Alarms: 'Тревоги',
  All: 'Все',
  'All-time statistics': 'За все время',
  Amount: 'Сумма',
  Allowed: 'Разрешено',
  'Amount in coin': 'Сумма в монетах',
  'Amount in currency': 'Сумма в валюте',
  'Amount owed': 'Сумма задолженности',
  'Api Key': 'Ключ API',
  Appointments: 'Назначения',
  Assignments: 'Назначения',
  Assignment: 'Назначение',
  'Appointment date': 'Дата назначения',
  Apply: 'Применить',
  'App version': 'Версия приложения',
  'Are sure you want to delete this item': 'Вы уверены, что хотите удалить этот элемент',
  'Are you sure you wish to send push notifications to all clients of this project':
    'Вы уверены, что хотите отправить push-уведомление всем клиентам проекта',
  'Are you sure you wish to send push notifications to all clients in selected region':
    'Вы уверены, что хотите отправить push-уведомление всем клиентам выбранного региона',
  'Messages are being sent': 'Сообщения отправляются',
  'Assigned to': 'Назначена на',
  'Assign a bag': 'Назначить сумку',
  'Assigned to groups': 'Назначен на группы',
  'Unit has been added to group': 'Объект добавлен в группу',
  'Are you sure you want to remove unit from this group?': 'Действительно убрать объект из группы?',
  'Read-only access': 'Доступ с правами "только чтение"',
  'Select users': 'Выберите пользователей',
  'At least one element must be added': 'Должен быть добавлен хотя бы один элемент',
  'At least one notification type must be selected': 'Должен быть выбран хотя бы один тип уведомления',
  'At least two items must be selected': 'Необходимо выбрать как минимум две услуги',
  'At least one field must be filled in': 'Необходимо заполнить хотя бы одно поле',
  'At least one option must be selected': 'Необходимо выбрать хотя бы одно поле',
  Audio: 'Аудио',
  'Authentication method': 'Способ аутентификации',
  'Availability in application': 'Доступность в приложении',
  Availability: 'Доступность',
  'in application': 'в приложении',
  Initiator: 'Инициатор',
  'Order completion initiator': 'Инициатор завершения заказа',
  'Order cancellation initiator': 'Инициатор отмены заказа',
  'Avail.': 'Дост.',
  Available: 'Доступен',
  Accessible: 'Доступные',
  'Available time': 'Доступное время',
  'Available units': 'Доступные объекты',
  'Count of trips per one unit per day': 'Количество поездок на один объект в сутки',
  'Total price of trips per one unit': 'Cтоимость заказов на объект за период',
  'Total price of trips per one unit per day': 'Cтоимость заказов на объект за сутки',
  'Active objects': 'Активные объекты',
  'Not available': 'Снят с доступа',
  'On charge': 'На зарядке',
  'At warehouse': 'На складе',
  'Attached to unit': 'Подключено к объекту',
  'Attached tracker': 'Подключенный трекер',
  'Under repair': 'В ремонте',
  'Unpaid orders': 'Неоплаченные заказы',
  'Unpaid fines': 'Неоплаченные штрафы',
  'Availability schedule': 'Расписание доступности',
  'Average cost': 'Средняя стоимость',
  Average: 'Средняя',
  'Average distance': 'Среднее расстояние',
  'Average duration': 'Средняя длительность',
  'Awaiting confirmation': 'Ожидание подтверждения',
  Awaiting: 'Ожидание',
  'A new refund operation will be created in the related operations if you try again.': 'При повторной попытке  в связанных операциях будет создана новая операция возврата.',
  Attention: 'Внимание',
  'A short description of the subscription is displayed in the list of subscriptions in the Subscription catalog section in the mobile application':
    'Краткое описание абонемента отображается в списке абонементов раздела Каталог абонементов в мобильном приложении',
  'A detailed description of the subscription is displayed in the subscription card in the mobile application':
    'Подробное описание абонемента отображается в карточке абонемента в мобильном приложении',
  'A document can be added either by adding text to the fill-in field or by uploading a file containing the document text.': 'Документ можно добавить как путем добавления текста в поле заполнения, так и при помощи загрузки файла, содержащего текст документа.',
  After: 'Через',
  'Baby carriages': 'Коляски',
  'Baby carriage': 'Коляска',
  'Baby carriage price': 'Цена коляски',
  Balance: 'Баланс',
  Bags: 'Сумки',
  'Bag number': 'Номер сумки',
  'List of bag numbers': 'Список номеров сумок',
  'Balance AuthCall': 'Баланс AuthCall',
  'Balance History': 'История баланса',
  'Balance packages': 'Бонусные пакеты',
  'Balance replenishment': 'Пополнение баланса',
  'Balance replenishment in currency': 'Пополнение баланса в валюте',
  'Balance 2023': 'Баланс 2023',
  'Top-up balance 2023': 'Пополнить баланс 2023',
  'Top-up': 'Пополнить',
  'Top-up of personal account balance': 'Пополнение баланса лицевого счета',
  'User balance 2023': 'Баланс пользователя 2023',
  Batteries: 'Батареи',
  'Battery charge': 'Заряд батареи',
  'Battery charge calculation settings': 'Настройка вычисления заряда АКБ',
  'Battery lock: no information': 'Замок батареи: нет информации',
  'Battery lock: Closed': 'Замок АКБ:Закрыт',
  'Battery lock: Open': 'Замок АКБ: Открыт',
  'Battery mount type': 'Тип размещения АКБ',
  'Battery before replacement': 'Батарея до замены',
  'Battery after replacement': 'Батарея после замены',
  'Battery: Attached to unit': 'Подключена к объекту',
  'Branch offices': 'Филиалы',
  'Branch office': 'Филиал',
  'Select a project for battery.': 'Выберите проект, в котором создается батарея.',
  'Select a project for the hardware model you are creating': 'Выберите проект, в котором создается модель оборудования',
  'Select a project for the document you are creating': 'Выберите проект, в котором создается документ',
  'Select a country for the document you are creating': 'Выберите страну, для которой создается документ',
  'Select a business model for the document you are creating': 'Выберите бизнес-модель, для которой создается документ',
  'Select a unit type for the document you are creating': 'Выберите тип объекта, для которого создается документ',
  'Select a project for the region you are creating': 'Выберите проект, в котором создается регион',
  'Select a project for the geofence you are creating': 'Выберите проект, в котором создается геозона',
  'Select a project for the geopoint you are creating': 'Выберите проект, в котором создается геоточка.',
  'Select a project for the icon you are creating': 'Выберите проект, в котором создается иконка.',
  'Select the project country for the geofence you are creating': 'Выберите страну проекта, в которой создается геозона',
  'Select the project country for the geopoint you are creating': 'Выберите страну проекта, в которой создается геоточка.',
  'Select the country region for the geofence you are creating': 'Выберите регион страны, в котором создается геозона',
  'Select the project country for the region you are creating': 'Выберите страну проекта, в которой создается регион',
  'Select the project country in which battery will be used.': 'Выберите страну проекта, в которой будет применяться батарея.',
  'Select the country region for the geopoint you are creating': 'Выберите регион страны, в котором создается геоточка.',
  'Select the business-model for the geopoint you are creating': 'Выберите бизнес-модель, для которой создается геоточка.',
  'Specify the owner of the battery.': 'Укажите владельца батареи.',
  'Assign battery to the region in which it will be used.': 'Назначьте батарею на регион, в котором она будет эксплуатироваться.',
  'Enter the battery name.': 'Введите название батареи.',
  'Registration number must match the number specified in the battery name. Based on the specified registration number, the system generates a QR code required to assign the battery to the unit. Registration number is entered manually to assign the battery if it\'s impossible to scan the QR code.':
  'Регистрационный номер должен соответствовать указанному номеру в названии батареи. На основании указанного регистрационного номера системой генерируется QR-код, необходимый для назначения батареи на объект. Если по какой-то причине QR-код не считывается, для назначения батареи ввод регистрационного номера осуществляется вручную.',
  'Provide the battery serial number.': 'Укажите серийный номер батареи.',
  'If the battery is already installed, select the unit. Otherwise, leave the field blank.':
  'Если батарея уже установлена, выберите объект. В противном случае, оставьте поле пустым.',
  'Activate if there is a tracker installed in the battery.': 'Активируйте, если в батарее установлен трекер.',
  'If tracker has already been added to the system earlier, to be able to assign the tracker, select the "Select existing" option. To add a new tracker to the system with automatic assignment to the battery, select the "Add new" option.':
  'Если трекер уже был добавлен в систему ранее, для получения возможности назначить трекер выберите вариант "Выбрать существующий". Для добавления нового трекера в систему с автоматическим назначением на батарею, выберите вариант "Добавить новый".',
  'Select a tracker to assign to the battery.': 'Выберите трекер для назначения на батарею.',
  'Enter the tracker name.': 'Введите название трекера.',
  'Select the tracker model.': 'Выберите модель трекера.',
  'Specify the model of telematics equipment installed. Depending on the selected model, the correct operation of message reception, sending commands and functional features of the equipment depends on it.':
  'Укажите модель телематического оборудования, установленного в ваш объект. В зависимости от выбранной модели оборудования зависит корректность работы приема сообщений, отправки команд и функциональных особенностей оборудования.',
  'Specify the IMEI of the telematics equipment installed. Equipment communication with the server depends on the correctness of the specified IMEI. It is recommended to check the correctness of the entered data several times.':
  'Укажите IMEI телематического оборудования, установленного в ваш объект. От корректности указанного IMEI зависит связь оборудования с сервером. Рекомендуется несколько раз проверить корректность введенных данных.',
  'Enter the number of the SIM card installed in the telematics equipment.': 'Укажите номер SIM-карты, установленной в телематическом оборудовании.',
  'Choose tracker': 'Выберите трекер',
  'Change battery charge calculation method': 'Изменить метод вычисления заряда АКБ',
  'Enter SIM number': 'Введите номер SIM',
  'Enter the serial number' : 'Введите серийный номер',
  'Enter the courier UID' : 'Введите UID курьера',
  'Add device': 'Добавить устройство',
  'Enter serial number of device': 'Введите серийный номер устройства',
  'Device successfully added': 'Устройство успешно добавлено',
  Devices: 'Устройства',
  'Co-owned devices': 'Совладелец устройств',
  'Are you sure you want to remove selected device from the courier?': 'Вы уверены, что хотите удалить выбранное устройство у курьера?',
  'Assign device': 'Назначить устройство',
  'Purchases of devices': 'Покупки устройств',
  'Purchase information': 'Сведения о покупке',
  'Enter tracking number (optional)': 'Введите трек-номер (необязательно)',
  'For couriers': 'Для курьеров',
  'For QR sharing': 'Для QR-шеринга',
  'Price plans for couriers': 'Тарифы для курьеров',
  'Price plans for qr sharing': 'Тарифы для QR-шеринга',
  'Internal name (for admin panel)': 'Внутреннее имя (для админ-панели)',
  'Internal name': 'Внутреннее название',
  'Payment in advance ... days before the start of the next subscription period':
    'Оплата заранее за ... дней до начала следующего периода подписки',
  'Duration of subscription period, days': 'Длительность периода подписки, дней',
  'Duration, days': 'Длительность, дней',
  'Price plan group': 'Группа тарифов',
  'Group of price plans': 'Группа тарифов',
  'Groups of price plans for couriers': 'Группы тарифов для курьеров',
  'Auto-renewal': 'Автопродление',
  Billing: 'Биллинг',
  'Action on payment failure': 'Действие при неоплате',
  'Start subscription automatically when unit becomes online': 'Начинать подписку автоматически когда устройство выйдет на связь',
  'Default price plan': 'Тариф по умолчанию',
  'Price plan in case of payment failure': 'Фиксированный тариф в случае неоплаты',
  'Billing interval type': 'Тип интервала тарификации',
  'Number of full free of charge intervals': 'Количество бесплатных полных интервалов',
  Title: 'Название',
  'First partial month is free of charge': 'Первый неполный месяц предоставляется бесплатно',
  'Do not make payments for the next period and suspend service if unit is offline':
    'Не проводить платежи за следующий период и приостановить обслуживание, если объект не на связи',
  'Days between last message from the unit and next interval': 'Количество дней между последним сообщением и началом следующего интервала',
  'Resume service and payments if unit is back online': 'Продолжить обслуживание и платежи, если объект вернулся на связь',
  'Maximum allowed debt before cancelling service': 'Максимальная задолженность перед прекращением обслуживания',
  'Free of charge': 'Бесплатный',
  'Unit owner': 'Владелец объектов',
  'executor-subscription': 'Подписка',
  'executor-subscriptions': 'Подписки',
  'executor-has-subscriptions': 'Есть подписки',
  Intervals: 'Интервалы',
  'executor-unit-service': 'Обслуживание',
  'Service active until': 'Обслуживание активно до',
  'Default price plan group for couriers': 'Группа курьерских тарифов по умолчанию',
  'Managing of courier price plans': 'Создание тарифов и групп тарифов для курьеров',
  'Allow couriers to operate without subscriptions': 'Курьеры работают без подписки',
  default: 'по умолчанию',
  'Service is active': 'Обслуживание активно',
  'Blocked from': 'Дата блокировки',
  'Reason of blocking': 'Причина блокировки',
  'Price plan group of the next interval': 'Группа тарифов для следующего интервала',
  'Price plan of the next interval': 'Тариф для следующего интервала',
  'Date of next payment': 'Дата следующего платежа',
  Modify: 'Изменить',
  Device: 'Устройство',
  'Installed tracker': 'Установленный трекер',
  'Name of charge parameter': 'Название параметра',
  'Parameter value when charge is 0%': 'Значение параметра при заряде АКБ 0%',
  'Parameter value when charge is 100%': 'Значение параметра при заряде АКБ 100%',
  'Battery registration status in the system': 'Статус регистрации батареи в системе',
  'Actions on start of the trip': 'Действия при старте поездки',
  'Actions minutes before finish of the trip': 'Действия за несколько минут перед завершением поездки',
  'Time before finish of the trip': 'Время перед завершением поездки',
  'Actions on finish of the trip': 'Действия при завершении поездки',
  'Actions on leaving ride allow area': 'Действия при выезде за пределы зоны, разрешенной для катания',
  'Actions on entering ride allow area': 'Действия при возврате в зону, разрешенную для катания',
  'Execute actions minutes before finish of the trip': 'Выполнить действия за несколько минут до завершения поездки',
  'Number of minutes before finish of the trip': 'Минут до завершения поездки',
  'Anonymous client': 'Анонимный клиент',
  'Duration, minutes': 'Длительность, минут',
  'Action not selected': 'Действие не выбрано',
  'Presence in the system': 'Наличие в системе',
  'Select unit': 'Выберите объект',
  'Select a hardware model': 'Выберите модель оборудования',
  'SIM number': 'Номер SIM',
  'Type registration number': 'Укажите регистрационный номер',
  'Tracker attached': 'Установлен трекер',
  'Birth date': 'Дата рождения',
  'Billing model': 'Порядок оплаты',
  'Billing period': 'Расчетный период',
  'Business model': 'Бизнес-модель',
  'Business models': 'Бизнес-модели',
  'All projects': 'Все проекты',
  'All business models': 'Все бизнес-модели',
  'Insufficient funds to continue service': 'Недостаточно денежных средств для продолжения обслуживания',
  'out of': 'из',
  'Old billing': 'Старый биллинг',
  'of your units were hidden and not available for rent to clients': 'ваших объектов были скрыты и недоступны для аренды клиентам',
  'To resume service, you need to top up the balance': 'Для возобновления обслуживания необходимо пополнить баланс',
  'If you have any questions, please contact your manager': 'В случае возникновения вопросов обратитесь к Вашему менеджеру',
  'To ensure that push notification text displays on all screens (including small smartphones), it\'s recommended to limit it to 60-80 characters, including spaces.': 'Для гарантированного отображения текста пуш-уведомления на любых экранах (включая небольшие смартфоны) рекомендуется укладывать текст — в 60–80 символов с пробелами.',
  'If tracker is connected to a removable battery, select the "Removable battery" connection method. If tracker is connected to unit with a non-removable battery, select the "Unit" connection method.':
   'Если трекер подключается к съемной АКБ, выберите метод подключения "Съемный АКБ". Если трекер подключается к объекту с несъемным АКБ, выберите метод подключения "Объекты".',
  'Is paid': 'Оплачено',
  'Created at': 'Дата создания',
  'Paid at': 'Дата оплаты',
  'Paid orders': 'Оплаченные заказы',
  'Operation type': 'Тип операции',
  'Amount in payment currency': 'Сумма в валюте оплаты',
  'Accounting period': 'Расчетный период',
  'Bicycle price': 'Цена велосипеда',
  'Bicycle car price': 'Цена веломобиля',
  'Blink lights': 'Мигнуть светом',
  Facilities: 'Удобства',
  'From last': 'От последней',
  'From first': 'От первой',
  Finance: 'Финансы',
  'Being in a parking area': 'Нахождение в зоне парковки',
  'Being in the riding area': 'Нахождение в зоне катания',
  Beginning : 'Начало',
  Block: 'Заблокировать',
  Unblock: 'Разблокировать',
  'Block device': 'Забл. устройство',
  'Block engine': 'Забл. двигатель',
  Blocked: 'Заблокирован',
  Unlocked: 'Разблокирован',
  'Blocked-statistic': 'Заблокированные',
  'Blocked since': 'Дата блокировки',
  'Bookd.': 'Бронь',
  'Booking timeout': 'Таймаут бронирования',
  'Booking timed out': 'Время брони истекло',
  Booking: 'Бронирование',
  Boundary: 'Границы',
  Bonuses: 'Бонусы',
  Brief: 'Кратко',
  'Browser window is inactive': 'Окно браузера неактивно',
  'Cancel transaction': 'Отменить транзакцию',
  'Cancellation date': 'Дата отмены',
  'Can create price plans': 'Может создавать тарифные планы',
  Call: 'Позвонить',
  Canceled: 'Отмененный',
  'canceled-status': 'Отменен',
  Canceled_: 'Отменена',
  Cancelled: 'Отмененный',
  'Cancelled orders': 'Отмененные заказы',
  'Cannot change status because unit\'s owner is blocked': 'Невозможно сменить статус поскольку владелец объекта заблокирован',
  Car: 'Автомобиль',
  Cars: 'Автомобили',
  'Electric mopeds': 'Электромопеды',
  'Calculation method': 'Метод расчёта',
  'Categories of transport licenses:': 'Категории прав для транспорта:',
  Bikes: 'Велосипеды',
  Bike: 'Велосипед',
  Velomobiles: 'Веломобили',
  'Velomobile price': 'Цена веломобиля',
  voltage_abbreviation: 'В',
  Apartments: 'Квартиры',
  Charge: 'Заряд',
  Couriers: 'Курьеры',
  Courier: 'Курьер',
  'charge-level-low': 'Низкий (скрыто в приложении)',
  'charge-level-medium': 'Средний',
  'charge-level-high': 'Высокий',
  'Charge/fuel level': 'Уровень заряда/топлива',
  'Charge at finish': 'Заряд на финише',
  'Charge at start': 'Заряд при старте',
  'Charge when plugged in': 'Заряд при подключении',
  'Charge not found': 'Заряд не найден',
  'Charging stations': 'Зарядные станции',
  Boats: 'Лодки',
  Boat: 'Лодка',
  kWh: 'кВт⋅ч',
  Partners: 'Партнёры',
  'Port 1': 'Порт 1',
  'Port 2': 'Порт 2',
  'Port 3': 'Порт 3',
  'Port 4': 'Порт 4',
  'Port 1 connector type': 'Порт 1, тип коннектора',
  'Port 2 connector type': 'Порт 2, тип коннектора',
  'Port 3 connector type': 'Порт 3, тип коннектора',
  'Port 4 connector type': 'Порт 4, тип коннектора',
  Polygon: 'Полигон',
  'Checkout bonus': 'Бонус при завершении заказа',
  'Charge before replacement': 'Заряд до замены',
  'Charge after replacement': 'Заряд после замены',
  'Choose a day of the week': 'Выберите день недели',
  'Choose a status': 'Выберите статус',
  'Choose a color': 'Выбрать цвет',
  'Choose a sign': 'Выберите знак',
  'Choose status': 'Выберите статус',
  'Choose the language for the rate information provided.': 'Укажите язык, на котором предоставляется информация о тарифе.',
  'Choose an integrator': 'Выберите интегратора',
  'Choose the regions': 'Выберите регионы',
  'Choose access rights': 'Выберите права доступа',
  'Choose the acquiring': 'Выберите эквайринг',
  'Choose the payment service': 'Выберите сервисы',
  'Choose a removable battery': 'Выберите съемную АКБ',
  'Choose at least one language': 'Выберите минимум один язык',
  'Choose file': 'Выберите файл',
  'Choose from the list': 'Выбрать из списка',
  'Choose a business model': 'Выберите бизнес-модель',
  'Choose group of price plans': 'Выберите группу тарифов',
  City: 'Город',
  Circle: 'Окружность',
  Clear: 'Очистить',
  Client: 'Клиент',
  'Number of selected clients': 'Количество выбранных клиентов',
  'Client authentication': 'Аутентификация клиента',
  'Number of clients selected': 'Выбрано клиентов',
  'Client awaiting confirmation': 'Клиент ожидает подтверждения',
  'Client blocked': 'Клиент заблокирован',
  'Client coord': 'Координаты клиента',
  'Client not confirmed': 'Клиент не подтвержден',
  'Client photo': 'Фотография клиента',
  'Client price plans': 'Тарифы',
  'Client statistics': 'Клиенты',
  'Client selection': 'Выбор клиентов',
  'Client assignment method': 'Метод назначения клиентов',
  Clients: 'Клиенты',
  'Group of clients': 'Группа клиентов',
  'Client groups': 'Группы клиентов',
  'Unit groups': 'Группы объектов',
  'Client notification log': 'Журнал по клиентам',
  'Clients who can pre-test the route': 'Клиенты, которым доступно предварительное тестирование маршрута',
  'Client notification settings': 'Настройка уведомлений по клиентам',
  'Client notifications triggers log': 'Журнал уведомлений по клиентам',
  'Client registration type': 'Тип регистрации клиента',
  'Client rating': 'Оценка клиента',
  'Client review': 'Отзыв клиента',
  'Client rating and review': 'Оценка и отзыв клиента',
  'Log of notifications by clients': 'Журнал уведомлений по клиентам',
  'Click here and then select position on map': 'Щелкните здесь и затем выберите место на карте',
  'Close alarm with description': 'Закрыть тревогу, указав описание',
  'Close alarm': 'Закрыть тревогу',
  'Close door': 'Закрыть дверь',
  'Close window': 'Закрыть окно',
  'Close a branch': 'Закрыть филиал',
  'Closed by': 'Закрыто пользователем',
  'Closed requests': 'Закрытые',
  'Closed services': 'Закрытые заявки',
  Closed: 'Закрыт',
  'Closing date': 'Дата закрытия',
  'Coin value': 'Стоимость коина',
  'Collapse menu': 'Свернуть меню',
  Color: 'Цвет',
  Coordinates: 'Координаты',
  'coordinates-ok': 'Есть координаты',
  'coordinates-invalid': 'Невалидные',
  'Color name': 'Название цвета',
  'Color setting': 'Настройка цвета',
  'Command descriptions': 'Описание команд',
  'Command name': 'Имя команды',
  'Command text': 'Текст команды',
  'Command to disable speed limit' : 'Команда отключения ограничения скорости',
  Commands: 'Команды',
  Command: 'Команда',
  'Command batch': 'Рассылка команд',
  'Command text can only contain latin letters, numbers, punctuation signs':
    'Текст команды может включать только цифры, латинские буквы, знаки препинания',
  'Commands were put to queue for sending': 'Команды были поставлены в очередь на отправку',
  'Command was put to queue for sending': 'Команда была поставлена в очередь на отправку',
  'Comment will be used for administrative purposes only and will not be available to the client.':
    'Комментарий используется только в административных целях и не будет доступно клиенту.',
  Comments: 'Комментарии',
  Commentator: 'Комментатор',
  'Confirm booking': 'Подтвердить бронирование',
  'Confirm Email': 'Подтвердить Email',
  'connection-status-offline': 'Не на связи',
  'connection-status-online': 'На связи',
  'Connection status': 'Статус подключения',
  Connecting: 'Подключение',
  'Coordinated were copied to clipboard': 'Координаты скопированы в буфер обмена',
  'Geofence limit reached. Increase map zoom to show all geofences.':
    'Превышен лимит числа геозон на карте. Увеличьте масштаб, чтобы видеть все геозоны',
  'Geopoint limit reached. Increase map zoom to show all geopoints.':
    'Превышен лимит числа геоточек на карте. Увеличьте масштаб, чтобы видеть все геоточки',
  'Unit limit reached. Increase map zoom to show all units.':
    'Превышен лимит числа объектов на карте. Увеличьте масштаб, чтобы видеть все объекты',
  'Click on map to freeze coordinates': 'Щелчок по карте - фиксация координат',
  'Copy notification': 'Копировать уведомление',
  Count: 'Кол-во',
  'Count-statistic': 'Количество',
  Cost: 'Стоимость',
  'Net cost': 'Себестоимость',
  'Net cost information': 'Информация по себестоимости',
  'Count of selected units': 'Объектов выбрано',
  'Count of selected clients': 'Клиентов выбрано',
  'Cost of orders': 'Стоимость заказов',
  'Deal type': 'Тип сделки',
  Documents: 'Документы',
  'Document type': 'Тип документа',
  'Document type not selected': 'Тип документа не выбран',
  'Document format': 'Формат документа',
  'Document text': 'Текст документа',
  'Document text (HTML)': 'Текст документа (HTML)',
  'Document addition method': 'Метод добавления документа',
  'Type not selected': 'Тип не выбран',
  'Does not work': 'Не работает',
  Works: 'Работает',
  'Duration not selected': 'Продолжительность не выбрана',
  Send: 'Отправить',
  Settings: 'Настройки ',
  'Other settings': 'Другие настройки',
  'Last command': 'Последняя команда',
  'Sending time': 'Время отправки',
  Compact: 'Компактный',
  Completed: 'Завершённые',
  Components: 'Комплектующие',
  'Components without s/n': 'Комплектующие без с/н',
  'Comparison type': 'Тип сравнения',
  'Component models': 'Модели комплектующих',
  'Component types': 'Типы комплектующих',
  Company: 'Компания',
  Condition: 'Условие',
  Confirmed: 'Подтвержденный',
  'Confirmed Client': 'Подтвержденный клиент',
  'Confirmed documents': 'Подтвержденные документы',
  Connection: 'Соединение',
  'Connection method': 'Метод подключения',
  'Connected by user': 'Подключена пользователем',
  'Connect tracker': 'Подключить трекер',
  'Connect battery': 'Подключить батарею',
  'Connected to an object': 'Подключен к объекту',
  'Connected to battery': 'Подключен к батарее',
  'Copy of': 'Копия',
  Countries: 'Страны',
  Country: 'Страна',
  'Country Code': 'Код Страны',
  'Country of registration': 'Страна регистрации',
  Create: 'Создать',
  Creation: 'Создание',
  'Create new SMS Gateway': 'Создать СМС-шлюз',
  'Create new acquirer': 'Создать эквайер',
  'Create new balance package': 'Создать бонусный пакет',
  'Create new subscription': 'Создать абонемент',
  'Create new command description': 'Создать описание команды',
  'Create new end-user-price-plan': 'Создать клиентский тарифный план',
  'Create new model group': 'Создать группу моделей',
  'Create new plan': 'Создать тарифный план для интегратора',
  'Create new project': 'Создать проект',
  'Create new region': 'Создать регион',
  'Create new insurance': 'Создать страховку',
  'Create new route': 'Создать маршрут',
  'Create new unit': 'Создать объект',
  'Create new unit model': 'Создать модель объекта',
  'Create new unit-command-text': 'Создать команду для объекта',
  'Create new unit-hw-model': 'Создать модель девайса',
  'Create new user': 'Создать пользователя',
  'Create a field': 'Создать поле',
  'Create unit group': 'Создать группу объекта',
  'Creating a client group': 'Создание группы клиентов',
  'Creating a group': 'Создание группы',
  'Creating a scooter': 'Создание самоката',
  'Creating a car': 'Создание автомобиля',
  'Creating a bicycle': 'Создание велосипеда',
  'Creating an electric bicycle': 'Создание электровелосипеда',
  'Creating a bicycle car': 'Создание веломобиля',
  'Creating a tricycle': 'Создание трицикла',
  'Creating a tracker': 'Создание трекера',
  'Creating a baby carriage': 'Создание коляски',
  'Creating a trailer': 'Создание прицепа',
  'Creating an electric quad bike': 'Создание электроквадроцикла',
  'Creating a charging station': 'Создание зарядной станции',
  'Creating business model': 'Создание бизнес-модели',
  'Creation date': 'Дата открытия',
  'Credit amount': 'Сумма зачисления',
  Creator: 'Создатель',
  Currency: 'Валюта',
  Changelog: 'Журнал изменений',
  'Criteria for achieving the level': 'Критерии достижения уровня',
  'Evaluation criterion': 'Критерий оценки',
  Dashboard: 'Дашборд',
  'Data will not be updated': 'Данные не будут обновляться',
  'Data type': 'Тип данных',
  'Select data type': 'Выберите тип данных',
  'Date of completion': 'Дата завершения',
  'Date of registration': 'Дата оформления',
  'Date of creation': 'Дата создания',
  'Date of registration confirmation': 'Дата подтверждения регистрации',
  'Date of issue of the document': 'Дата оформления документа',
  'Date modified': 'Дата изменения',
  'Display order': 'Порядок отображения',
  'Select display order': 'Выберите порядок отображения',
  Day: 'День',
  'Day of week': 'День недели',
  Days: 'Дней',
  'Days before blocking': 'Количество дней в минус',
  'Default (cheapest)': 'По умолчанию (самый дешевый)',
  'Default language': 'Язык по умолчанию',
  'Default timezone': 'Часовой пояс по умолчанию',
  'Default country': 'Страна по умолчанию',
  'Default business model': 'Бизнес-модель по умолчанию',
  Delete: 'Удалить',
  'Delete geofence?': 'Удалить геозону',
  'Delete price plan': 'Удалить тариф',
  'Delete language': 'Удалить язык',
  'Delete point': 'Удалить точку',
  'Delete route': 'Удалить маршрут',
  'Delete image': 'Удалить фото',
  'Delete video': 'Удалить видео',
  'Demand coefficient': 'Коэффициент спроса',
  'Demand assessment areas': 'Области оценки спроса',
  'Demand area': 'Область оценки спроса',
  Description: 'Описание',
  Destination: 'Предназначение',
  'Destination type': 'Тип назначения',
  'Designated region': 'Регион назначения',
  'Destination ID': 'ID назначения',
  'Description title 1': 'Заголовок описания 1',
  'Description title 2': 'Заголовок описания 2',
  'Description title 3': 'Заголовок описания 3',
  'Description title 4': 'Заголовок описания 4',
  'Description value 1': 'Описание 1',
  'Description value 2': 'Описание 2',
  'Description value 3': 'Описание 3',
  'Description value 4': 'Описание 4',
  'Description speed mode': 'Описание, скоростной режим',
  'Description price plan cost': 'Описание, стоимость тарифа',
  Insurance: 'Страховка',
  'Insurance detail': 'Описание страховки',
  'Insurance link': 'Ссылка на описание страховки',
  Insurers: 'Страховщики',
  'Insurance price for admin': 'Стоимость страховки для админа',
  'Insurance price for integrator': 'Стоимость страховки для интегратора',
  'Insurance canceled': 'Страховка аннулирована',
  'is awaiting for confirmation': 'ожидает подтверждения',
  Import: 'Импорт',
  Repeater: 'Ретранслятор',
  Token: 'Токен',
  'Unit list edit mode': 'Метод редактирования списка объектов',
  'Data content type': 'Содержание данных для импорта',
  'Data for import': 'Данные для импорта',
  'Import mode': 'Режим импорта',
  'Unit assignment type': 'Тип назначения объектов',
  Comment: 'Комментарий',
  Detailed: 'Детально',
  'Detailed description': 'Подробное описание',
  'Device vendor': 'Производитель',
  'Device model': 'Модель',
  'Device info': 'Данные устройства',
  Dispatcher: 'Диспетчер',
  Diagnostics: 'Диагностика',
  'Distance, m': 'Расстояние, м',
  'Distance, km': 'Расстояние, км',
  'Duration, days (0 - infinite)': 'Продолжительность, дни (0 - без ограничений)',
  'Duration, hour': 'Продолжительность, часы',
  'Do you wish to change status and send command': 'Действительно сменить статус и отправить команду',
  'Do you wish to send command': 'Действительно отправить команду',
  Document: 'Документ',
  'Document photo': 'Фотография документа',
  'Document name (link to the document)': 'Название документа (ссылка на документ)',
  Documentation: 'Документация',
  'Document type not set': 'Тип документа не установлен',
  'Document consent required': 'Требуется согласие с документом',
  'Document expiration date': 'Дата окончания действия документа',
  'Document expiration date (Date of issue + 3 days)': 'Дата окончания действия документа (Дата оформления + 3 дня)',
  'draw polygon, please': 'Нарисуйте полигон, пожалуйста',
  'Documents with the "Country" assignment type are used to display to the client during registration and in the "Legal Documents" section. If you operate with multiple business models, you should add legal documents for each business model. If you need to add a document template populated with client and/or unit data, select the "Unit Type" assignment type.': 'Документы с типом назначения «Страна» используются для отображения клиенту при регистрации, а также для отображения в разделе «Правовые документы». Если вы работаете в разных бизнес-моделях, необходимо добавить правовые документы для каждой бизнес-модели. Если вам необходимо добавить шаблон документа, который заполняется данными клиента и/или объекта, выберите тип назначения «Тип объекта».',
  'Document template can be provided in two formats: Text and HTML. When you add a document in text format, it will be displayed as is, without formatting. Adding a document in HTML format allows you to display the document exactly as you want.': 'Шаблон документа можно предоставить в двух форматах: Текст и HTML. При добавлении документа в текстовом формате документ будет отображаться «как есть» без учета форматирования. Добавление документа в формате HTML предоставляет возможность отобразить документ именно так, как вы этого хотите.',
  Driver: 'Водитель',
  'Drivers license photo (Back side)': 'Водительские права фото (задняя сторона)',
  'Drivers license photo (Front side)': 'Водительские права фото (передняя сторона)',
  Edit: 'Редактировать',
  Editing: 'Редактирование',
  'Edit Balance': 'Редактировать баланс',
  'Edit balance': 'Редактировать баланс',
  'Edit insurance': 'Редактировать страховку',
  'Edit subscription': 'Редактировать абонемент',
  'Edit fare': 'Редактировать тариф',
  'Edit balance package': 'Редактировать бонусный пакет',
  'Edit Client': 'Редактировать клиента',
  'Edit command description': 'Редактировать описание команды',
  'Edit Geopoint': 'Редактировать геоточку',
  'Edit insurance balance': 'Редактировать баланс страхования',
  'Edit SMS Gateway': 'Редактировать СМС-шлюз',
  'Edit acquirer': 'Редактировать эквайера',
  'Edit end-user-price-plan': 'Редактировать тарифный план',
  'Edit model group': 'Редактировать группу моделей',
  'Edit price plan': 'Редактировать тарифный план',
  'Edit parts': 'Изменить части',
  'Edit plan': 'Редактировать тарифный план для интегратора',
  'Edit point': 'Редактировать точку',
  'Edit price plan structure': 'Редактировать структуру тарифного плана',
  'Edit project': 'Редактировать проект',
  'Edit promo code': 'Редактировать промокод',
  'Edit unit group': 'Редактировать группы объектов',
  'Promo Codes': 'Промокоды',
  'Promo code activations log': 'Журнал активации промокодов',
  'Purchase Services': 'Сервисы покупки',
  'Purchase date': 'Дата покупки',
  Purpose: 'Назначение',
  'Edit region': 'Редактировать регион',
  'Edit route': 'Редактировать маршрут',
  'Edit service request': 'Редактировать заявку',
  'Edit unit': 'Редактировать объект',
  'Edit unit model': 'Редактировать модель',
  'Edit unit-command-text': 'Редактировать команду',
  'Edit unit-hw-model': 'Редактировать модель девайса',
  'Edit user': 'Редактировать пользователя',
  'Edit group': 'Редактировать группу',
  'Editing a group': 'Редактирование группы',
  'Editing business model': 'Редактирование бизнес-модели',
  'Editable by integrator': 'Интегратор может редактировать',
  'Editing a charging station': 'Редакирование зарядной станции',
  'Editing a geofence': 'Редактирование геозоны',
  'Electric bike': 'Эл. велосипед',
  'Electric bike price': 'Цена эл. велосипеда',
  Employment: 'Трудоустройство',
  'Full name of the courier': 'ФИО курьера',
  'Current employment': 'Текущее трудоустройство',
  'Employment type': 'Тип занятости',
  'Courier groups': 'Группы курьеров',
  'Courier type': 'Тип курьера',
  'The method of appointing couriers': 'Метод назначения курьеров',
  'Employment history': 'История трудоустройства',
  Email: 'Email',
  'Email sender': 'Email отправителя',
  'Enable authentication calls': 'Включить аутентификационные звонки',
  'Enable password authentication for clients': 'Разрешить клиентам аутентификацию по паролю',
  'Enabled if unit status is': 'Включено, если статус объекта соответствует',
  'Enable OSM': 'Разрешить использование OSM',
  'Enable filtering of new coordinates': 'Включить фильтрацию новых координат',
  'Enable immediately after saving': 'Включить сразу после сохранения',
  'Disable coordinate outlier filtering': 'Выключить фильтрацию выбросов координат',
  Error: 'Ошибка',
  'This function is disabled for Moneta acquirer': 'Данная возможность для эквайринга Монета отключена',
  'Error of transaction cancelling': 'Ошибка отмены транзакции',
  'Error code': 'Код ошибки',
  'Event: ': 'Событие: ',
  'Event log': 'Журнал событий',
  'Extended registration': 'Расширенная регистрация',
  Extended: 'Расширенная',
  'Extended registration type': 'Тип расширенной регистрации',
  'Extended registration status': 'Статус прохождения расширенной регистрации',
  'Registration status': 'Статус регистрации',
  'Registration completion status': 'Статус прохождения регистрации',
  'Registration forms': 'Формы регистрации',
  'Registration form': 'Форма регистрации',
  'Expiry date': 'Действителен до',
  'Expiration date': 'Срок действия',
  'Ext. registration': 'Расш. регистрация',
  'Failed transaction type': 'Тип неудачной транзакции',
  'Field must be a real number': 'Поле должно быть числом',
  'Fields must match': 'Поля должны совпадать',
  'Field types': 'Типы полей',
  'Finish time': 'Время финиша',
  'Finish-time': 'Время завершения',
  Finished: 'Завершено',
  finished: 'Завершен',
  'Finished orders': 'Завершенные заказы',
  'Financial operations': 'Финансовые операции',
  'Last financial operation': 'Последняя финансовая операция',
  'Last operation': 'Последняя операция',
  'Last modified': 'Последнее изменение',
  'Recipient\'s account': 'Счет получателя',
  'First 6': 'Первые 6',
  'Latest 4': 'Последние 4',
  'File not selected': 'Файл не выбран',
  'File types': 'Типы файлов',
  'Select file types': 'Выберите типы файлов',
  'For balance in currency': 'Для баланса в валюте',
  'For subscriptions': 'Для абонементов',
  'Full description': 'Подробное описание',
  'Full screen mode': 'Полноэкранный режим',
  'Full name of the Individual Entrepreneur': 'ФИО Индивидуального предпринимателя',
  'statistics-finished': 'Завершенные',
  'statistics-cancelled': 'Отмененные',
  'Active clients': 'Активные клиенты',
  'general-statistic-active': 'Активные',
  'Inactive clients': 'Неактивные клиенты',
  'Blocked clients': 'Заблокированные клиенты',
  'By default': 'По умолчанию',
  'By default, linking a bank card to rent is required, regardless of the method of rent payment. If you want to provide services without the obligatory linking of a bank card, uncheck the box. Please note that disabling this setting may lead to the formation of debts and the inability to repay these debts.':
    ' По умолчанию привязка банковской карты для совершения аренды обязательна вне зависимости от способа оплаты аренды. Если вы хотите предоставлять услуги без обязательной привязки банковской карты, снимите влажок. Обращаем ваше внимание, что отключение данной настройки может привести к образованию задолженностей и невозможностью погасить эти задолженности.',
  '"By default" - holding is confirmed only in cases where the write-off amount is greater than or equal to the holding amount. "New customers" - holding is confirmed in the first order, regardless of the debit amount, the excess is credited to the client\'s balance. "All clients" - holding is always confirmed, the excess is credited to the client\'s balance.':
    '«По умолчанию» – холдирование подтверждается только в случаях суммы списания большей или равной сумме холдирования. «Новые клиенты» - холдирование подтверждается в первом заказе вне зависимости от суммы списания, излишек зачисляется на баланс клиента. «Все клиенты» - холдирование подтверждается всегда, излишек зачисляется на баланс клиента.',
  'Active users': 'Активные пользователи',
  'Inactive users': 'Неактивные пользователи',
  Filter: 'Фильтр',
  Filtering: 'Фильтрация',
  'Finish time of last order': 'Время завершения последнего заказа',
  Firmware: 'Прошивка',
  'First name': 'Имя',
  'First page passport photo': 'Первая страница паспорта с фотографией',
  'First rate selected by default': 'Выбор тарифа по умолчанию',
  'Form validation error': 'Ошибка проверки формы',
  'Form type': 'Тип формы',
  'Fuel tank volume': 'Объем топливного бака',
  'Fuel tank volume (L)': 'Объем топливного бака (л)',
  'Fuel type': 'Тип топлива',
  'GSM not found': 'GSM не найден',
  General: 'Общая',
  'General statistics': 'Общая статистика',
  'General information': 'Общая информация',
  'general-information': 'Общие сведения',
  Geofences: 'Геозоны',
  Geofence: 'Геозона',
  Geopoints: 'Геоточки',
  Geopoint: 'Геоточка',
  'Geopoint types': 'Типы геоточек',
  'geopoint-geometry-info-text': 'Укажите местоположение геоточки в пределах региона. Геоточка носит информационный характер. После указания местоположения геоточки нажмите “Сохранить”',
  'Geo objects': 'Геообъекты',
  'GPS status': 'Статус GPS',
  'GPS coordinates': 'Координаты GPS',
  'gps-status-offline': 'GPS не на связи',
  'gps-status-online': 'GPS на связи',
  'Give the region a name': 'Задайте название региону',
  Groups: 'Группы',
  Group: 'Группа',
  'HW model': 'Модель оборудования',
  'HW type': 'Тип оборудования',
  'Hair dryer': 'Фен',
  'Hardware ID': 'Идентификатор оборудования',
  'Hardware IMEI': 'IMEI оборудования',
  'Hardware models': 'Модели оборудования',
  'Hardware id of new tracker': 'Идентификатор оборудования нового трекера',
  'Hardware model of new tracker': 'Модель оборудования нового трекера',
  'Hardware parameters': 'Параметры оборудования',
  'Hardware type': 'Тип оборудования',
  'Has attachment files': 'Имеются прикрепленные файлы',
  'Has bank cards': 'Имеются банковские карты',
  'Has transaction by bank cards': 'Имеется транзакция по банковским картам',
  'Hasn\'t attachment files': 'Прикрепленные файлы отсутствуют',
  'Hasn\'t bank cards': 'Банковские карты отсутствуют',
  'Hasn\'t transaction by bank cards': 'Транзакции по банковским картам отсутствуют',
  'Has serial numbers': 'Есть серийные номера',
  Hidden: 'Скрыт',
  'Hide unit in application': 'Скрыть объект в приложении',
  'Hybrid vehicle': 'Гибридный',
  ID: 'ID',
  'Idle time more than (sec)': 'Длительность простоя более (сек)',
  Idle: 'Холостой',
  'If there is no rate translation into the language of the client\'s phone, client will be shown rate information in the default language. We recommend adding translation of the rate into the English and setting the default language of the rate to English.':
    'В случае отсутствия перевода тарифа на язык, соответствующий языку телефона клиента, клиенту будет отображаться информация о тарифе на языке по умолчанию. Рекомендуем добавить перевод тарифа на английский язык и установить английский языком тарифа по умолчанию',
  'Is published': 'Опубликован',
  'statistics-idle': 'Простаивает',
  'general-statistics-idle': 'Простой',
  Image: 'Изображение',
  'Increase balance by amount': 'Увеличить баланс на сумму',
  'Increase balance': 'Увеличить баланс',
  'Decrease balance': 'Уменьшить баланс',
  'In rent': 'В аренде',
  'In service': 'В сервисе',
  'In order': 'В заказе',
  'Hidden in the application': 'Скрыт в приложении',
  'In service time': 'Время в сервисе',
  'In the test mode, the subscription is available only to the specified clients-testers. In combat mode, the subscription will be available to all customers in the region':
    'В тестовом режиме работы абонемент доступен только указанным клиентам-тестировщикам. В боевом режиме абонемент будет доступен всем клиентам в регионе',
  'In the mobile application, the tariff in the list of tariffs will be displayed in the priority specified in this field.':
    'В мобильном приложении тариф в списке тарифов будет отображаться в приоритете, указанном в данном поле.',
  Info: 'Информация',
  'Information for clients': 'Информация для клиентов',
  'Information for the client': 'Информация для клиента',
  Integrator: 'Интегратор',
  Interest: 'Значение',
  'Integrator price plans': 'Тарифные планы для интегратора',
  Interface: 'Интерфейс',
  'Interval (hh:mm - hh:mm)': 'Интервал (чч:мм - чч:мм)',
  'Interval (hh:mm:ss - hh:mm:ss)': 'Интервал (чч:мм:сс - чч:мм:сс)',
  'Interval start time must be less than end time': 'Время начала интервала должно быть меньше чем время окончания',
  'Invalid e-mail address': 'Неверный адрес электронной почты',
  Journal: 'Журнал',
  Language: 'Язык',
  Languages: 'Языки',
  'Last Message Time': 'Время последнего сообщения',
  'Last message': 'Последнее сообщение',
  'Last name': 'Фамилия',
  'Last order time status': 'Врем завершения последнего заказа',
  'Last maintenance date': 'Дата последнего ТО',
  'Last maintenance mileage': 'Километраж последнего ТО',
  'Last comment': 'Последний комментарий',
  'Lights off': 'Выключить свет',
  'Lights on': 'Включить свет',
  Loading: 'Загрузка',
  'Loading tracks': 'Загрузка треков',
  'Loading Units': 'Загрузка объектов',
  'Loading Map': 'Загрузка карты',
  Location: 'Расположение',
  'location-status-parking-forbidden': 'Парковка запрещена',
  'location-status-parking-allowed': 'Парковка разрешена',
  'location-status-riding-forbidden': 'Ездить запрещено',
  'location-status-riding-allowed': 'Ездить разрешено',
  'Location status, riding': 'Статус положения в зоне катания',
  Locator: 'Локатор',
  'Create locator': 'Создать локатор',
  '1 hour': '1 час',
  '2 hours': '2 часа',
  '3 hours': '3 часа',
  '4 hours': '4 часа',
  '6 hours': '6 часов',
  '12 hours': '12 часов',
  '1 day': '1 день',
  '2 days': '2 дня',
  'Link expire time': 'Срок действия ссылки',
  'Locator link copied to clipboard': 'Ссылка на локатор скопирована в буфер обмена',
  'Locator link': 'Ссылка на локатор',
  'Lock type': 'Тип замка',
  'Lock price': 'Цена замка',
  Login: 'Логин',
  'Login as': 'Войти как',
  'Login history': 'История Войти как',
  Logout: 'Выход',
  'Log out': 'Выйти',
  Logo: 'Логотип',
  'Lower bound of the interval': 'Нижняя граница интервала',
  'Main filter': 'Главный фильтр',
  'Maximum icon width': 'Максимальная ширина иконки 64px',
  'Maximum icon height': 'Максимальный высота иконки 64px',
  'Maintenance log': 'Журнал ТО',
  'Manual top-up': 'Ручное пополнение',
  'Manual assignment of clients to a group': 'Ручное назначение клиентов на группу',
  'Create maintenance entry': 'Создать запись в журнале',
  Guests: 'Гостей',
  'Guest account type': 'Тип аккаунта гостя',
  'Edit maintenance entry': 'Редактировать запись в журнале',
  'Maintenance Interval Mileage, km': 'Интервал ТО, км',
  'maintenance-expired': 'Истекло',
  'Map image': 'Изображение карты',
  'Map services': 'Картографические сервисы',
  Map: 'Карта',
  'Maximum available number of uses': 'Максимальное количество использований',
  'Mechanical lock code': 'Код механического замка',
  'Merchant Id': 'ID Продавца',
  'Message Sender': 'Отправитель Сообщения',
  'Messages were sent': 'Сообщения отправлены',
  'The message sending task has been sent for processing': 'Задача на отправку сообщений отправлена в обработку',
  'Message sent': 'Сообщение отправлено',
  'Messages from trackers': 'Сообщения от трекеров',
  'Method of conducting': 'Способ проведения',
  'Middle name': 'Отчество',
  Mileage: 'Пробег',
  'Minutes ago': 'Минут назад',
  'Mobile device': 'Моб. устройство',
  Model: 'Модель',
  Moderator: 'Модератор',
  'Access to document moderation': 'Доступ к проверке документов',
  'Model of new tracker': 'Модель нового трекера',
  'Model group': 'Группа моделей',
  'Model groups': 'Группы моделей',
  'Model popularity': 'Популярность моделей',
  'Model ratio': 'Соотношение моделей',
  Models: 'Модели',
  Month: 'Месяц',
  Year: 'Год',
  Multicasting: 'Рассылка',
  Name: 'Название',
  'Name of new tracker': 'Имя нового трекера',
  'Name of the level': 'Название уровня',
  'Name and Surname': 'Имя и фамилия',
  'Navigation button': 'Кнопка перехода',
  New: 'Новый',
  new: 'новое',
  new_ones: 'Новые',
  'New alarms': 'Новые тревоги',
  'New Balance': 'Новый баланс',
  'New Client': 'Новый Клиент',
  'New clients': 'Новые клиенты',
  'New requests': 'Новые',
  'New icon': 'Новая иконка',
  'New - the partner has not yet started working due to the various circumstances, so the payment according to the specified payment terms is not carried out. Upon the fact of readiness for work, the status of the partner changes to the Active status, according to which the calculation is carried out on the basis of the specified payment terms. Blocked - the user has no access to the system due to manual blocking of the account by the parent. Parent Blocked - The user is blocked due to the blocking of the parent account.':
    'Новый – партнер ещё не приступил к работе в связи с проведением настроек, поэтому расчет по заданным условиям оплаты не осуществляется. По факту готовности к работе статус партнера переходит в статус Активен, по которому осуществляется расчет на основании указанных условий оплаты. Заблокирован – у пользователя нет доступа в систему в связи с ручной блокировкой родителем учетной записи. Заблокирован родитель – пользователь заблокирован в связи с блокировкой родительской учетной записи.',
  'Next maintenance': 'Следующее ТО',
  No: 'Нет',
  Yes: 'Да',
  'has-item-yes': 'Есть',
  'has-item-no': 'Нет',
  'Not assigned': 'Не назначенные',
  'Not operational': 'Неисправен',
  'notification-enabled': 'Включено',
  'Notification-enabled': 'Включено',
  'Notification events': 'Сработки уведомлений',
  'Notification will be sent when the client\'s activity level increases to the current level.':
    'Уведомление будет отправлено при повышении уровня активности клиента до текущего уровня.',
  'Notification will be sent when the client\'s activity level decreases to the current level.':
    'Уведомление будет отправлено при понижении уровня активности клиента до текущего уровня.',
  'require_end_user_bank_card-enabled': 'Включена',
  'require_end_user_bank_card-off': 'Выключена',
  'Not selected': 'Не выбран',
  Source: 'Источник',
  'One-time password source': 'Источник одноразового пароля',
  'Source type': 'Тип источника',
  'Source name': 'Источник',
  'Skip areas where the object is stationary': 'Пропускать участки где объект неподвижен',
  'No alarms': 'Нет тревог',
  'No signal': 'Нет сигнала',
  'No information': 'Нет информации',
  'No order finish photo': 'Нет фото завершения заказа',
  'No client profile photo': 'Нет фото клиента',
  'No photo of the courier': 'Нет фото курьера',
  'No executor photo': 'Нет фото исполнителя',
  'No unit model picture': 'Нет изображения модели объекта',
  'No new notifications': 'Нет новых уведомлений',
  'No cards available': 'Нет доступных карт',
  Now: 'Сейчас',
  'Number of free cancellations': 'Количество бесплатных отмен бронирования',
  'Number of luggage spaces': 'Мест для багажа',
  'Number of seats': 'Посадочных мест',
  'Number of clients': 'Количество клиентов',
  'Number of couriers': 'Количество курьеров',
  'n/a': 'н/п',
  'n/i': 'н/и',
  Offline: 'Не на связи',
  Off: 'Выкл.',
  'geofence-disabled': 'Выключены',
  'geofence-active': 'Включены',
  'geofence-boundaries-info-text': 'Воспользуйтесь инструментами карты, чтобы отрисовать границы геозоны. По факту соединения точек нажмите “Сохранить”',
  'geofence-boundaries-tech-type-info-text': 'Воспользуйтесь инструментами карты, чтобы отрисовать границы территории техника. По факту соединения точек нажмите “Сохранить”',
  'geofence-boundaries-demand-type-info-text': 'Воспользуйтесь инструментами карты, чтобы отрисовать границы области оценки спроса. По факту соединения точек нажмите “Сохранить”',
  'Switched off': 'Выключен',
  On: 'Вкл.',
  'Switched on': 'Включен',
  'Online available': 'Доступен',
  'Online in rent': 'Забронирован',
  'only with orders': 'С заказами',
  'only without orders': 'Без заказов',
  'Open door': 'Открыть дверь',
  'Open a branch': 'Открыть филиал',
  Operational: 'Исправен',
  'Or command text': 'Или текст команды',
  Order: 'Заказ',
  Task: 'Задание',
  System: 'Система',
  'Balance before operation': 'Баланс до операции',
  'Balance after operation': 'Баланс после операции',
  'Order events': 'События заказа',
  'Order count': 'Количество заказов',
  'Order duration': 'Длительность заказов',
  Duration: 'Длительность',
  'Order log': 'Журнал заказа',
  'Order status': 'Состояние заказа',
  'Order completion photo': 'Фото завершения заказа',
  'Reason for termination': 'Причина завершения',
  'Remaining minutes': 'Остаток минут',
  'Remaining trips': 'Остаток поездок',
  Remaining: 'Остаток',
  'Remove from access': 'Снять с доступа',
  'Removable battery': 'Съемная АКБ',
  Reading: 'Чтение',
  'order-status-active': 'Катающиеся',
  'order-status-booked': 'Забронированные',
  'order-status-available': 'Доступен',
  'order-status-not_available': 'Снят с доступа',
  'order-status-on_charge': 'На зарядке',
  'order-status-at_warehouse': 'На складе',
  'order-status-service_mode': 'В сервисе',
  'order-status-under_repair': 'В ремонте',
  'order-status-donor': 'Донор',
  'order-status-stolen': 'Украден',
  'order-status-free': 'Свободные',
  'order-status-hidden-in-application': 'Скрыты в приложении',
  'order-status-paused': 'На паузе',
  'Ordinal number': 'Порядковый номер',
  Orders: 'Заказы',
  'Orders count': 'Количество заказов',
  'OS type': 'Тип ОС',
  OS: 'ОС',
  'OS version': 'Версия ОС',
  'Out of rent': 'Вне аренды',
  Overview: 'Обзор',
  Owner: 'Владелец',
  Points: 'Точки',
  Radius: 'Радиус',
  Notification: 'Уведомление',
  Notifications: 'Уведомления',
  'Create new notification': 'Создать новое уведомление',
  'Edit notification': 'Редактировать уведомление',
  'All units in these projects': 'Все объекты в проектах',
  'All units of these models': 'Все объекты моделей',
  'All units owned by these users': 'Объекты, принадлежащие пользователям',
  'Units located in regions': 'Объекты, находящиеся в регионах',
  'All units loaded': 'Все объекты загружены',
  'All orders loaded': 'Все заказы загружены',
  'All orders loaded from cache': 'Все заказы загружены из кэша',
  'All clients': 'Все клиенты',
  'Registered clients': 'Зарегистрированные клиенты',
  Registered: 'Зарегистрированные',
  'Anonymous clients': 'Анонимные клиенты',
  Anonymous: 'Анонимные',
  'All executors': 'Все исполнители',
  Executor: 'Исполнитель',
  'Select executor': 'Выберите исполнителя',
  'My employee': 'Мои сотрудники',
  'Co-owners': 'Совладельцы',
  'Select co-owners': 'Выберите совладельцев',
  Message: 'Сообщение',
  'Minimum charge': 'Минимальный заряд ',
  'Maximum charge': 'Максимальный заряд',
  'Maximum speed': 'Максимальная скорость',
  'Positioning loss more than (seconds)': 'Потеря позиционирования более чем (сек)',
  'position-job': 'Должность',
  'Postpone check': 'Отложить проверку',
  'Connection loss more than (seconds)': 'Потеря связи более чем (сек)',
  'Charge less than (percent)': 'Заряд менее чем (%)',
  'Rent duration more than (seconds)': 'Длительность аренды более (сек)',
  'Rent duration': 'Длительность аренды',
  'Registration type': 'Тип регистрации',
  Registration: 'Регистрация',
  'Movement shorter than (seconds)': 'Движение менее (сек)',
  'Movement longer than (seconds)': 'Движение более (сек)',
  'Movement type': 'Тип передвижения',
  'Move to payment': 'Перейти к оплате',
  'Move up': 'Переместить вверх',
  'Move down': 'Переместить вниз',
  'Finish booking': 'Завершить бронирование',
  'Cancel booking': 'Отменить бронирование',
  // "Canceled": "Отменённые",
  Finish: 'Завершить',
  'Find orders': 'Поиск заказов',
  'Find by LBS': 'Найти по LBS',
  'Fuel level %': 'Уровень топлива %',
  'Cancel order': 'Отменить заказ',
  'Cancel subscription': 'Прекратить подписку',
  'Order already closed': 'Заказ уже закрыт',
  'Are sure you want to finish this order': 'Действительно завершить этот заказ',
  'Are sure you want to cancel this order': 'Действительно отменить этот заказ',
  'Are sure you want to cancel this transaction': 'Действительно отменить транзакцию',
  'Paid booking currency': 'Валюта платного бронирования',
  'Paid booking mode': 'Режим платного бронирования',
  'Paid booking price': 'Стоимость платного бронирования',
  'Parameter name': 'Имя параметра',
  'Passport photos': 'Фотографии паспорта',
  Password: 'Пароль',
  'Passwords do not match': 'Пароли не совпадают',
  'Password is required': 'Необходимо ввести пароль',
  'One-time password': 'Одноразовый пароль',
  'Multiple use password': 'Многоразовый пароль',
  'Payment method': 'Способ оплаты',
  'Payment conditions': 'Условия оплаты',
  'Payment procedure': 'Порядок оплаты',
  'Payment currency': 'Валюта оплаты',
  'Payment acceptance': 'Прием платежей',
  'Payment services': 'Сервисы покупок',
  'Payment amount': 'Сумма оплаты',
  'Payment failed': 'Ошибка проведения платежа',
  'Passport expiration date': 'Окончание срока действия паспорта',
  Citizenship: 'Гражданство',
  'Select citizenship': 'Укажите гражданство',
  Page: 'Страница',
  Period: 'Период',
  'Period of validity': 'Период действия',
  'Person type': 'Тип лица',
  'Personal data': 'Личные данные',
  'Percentage of revenue': 'Процент от выручки',
  'Percentage of order value': 'Процент от стоимости заказа',
  'Pending confirmation': 'Ожидают подтверждения',
  Phone: 'Телефон',
  'Phone / SIM number': 'Телефон / Номер SIM',
  'Photo report': 'Фотоотчет',
  'Photo of Registration': 'Фото прописки / регистрации',
  'Photo of Registration (New)': 'Фото прописки / регистрации (Новое)',
  'Phone number': 'Номер телефона',
  'Phone manufacturer and model': 'Производитель и модель телефона',
  'Photo gallery': 'Фотогалерея',
  photo: 'фото',
  Photography: 'Фотография',
  'Plate number': 'Гос. номер',
  'Planned payment terms': 'Запланированные условия оплаты',
  'Place of Birth': 'Место рождения',
  'Place of registration': 'Место регистрации',
  'Place of residence': 'Место проживания',
  'please, wait': 'пожалуйста, подождите',
  Position: 'Положение',
  Polyline: 'Полилиния',
  'please wait': 'пожалуйста, подождите',
  'Please add maintenance record': 'Добавьте записи о техобслуживании',
  'Please set up car mileage': 'Укажите текущий пробег автомобиля',
  'Please set up maintenance interval': 'Укажите интервал ТО',
  'Please provide a reason (Optional)': 'Укажите причину (Необязательно)',
  'Please enter your phone number in international format: start with "+" and include the country code.':
    'Введите номер телефона в международном формате: начните с «+» и укажите код страны.',
  'Please specify the name of the component type': 'Укажите название типа комплектующего',
  'Please specify the name of the component model': 'Укажите название модели комплектующего',
  'Please provide a free-form description of the model, such as specifications. This field is optional. and is currently only visible for the component model.':
    'Укажите описание модели в произвольной форме, например, характеристики. Поле не обязательное для заполнения и, в настоящий момент, отображается только у модели комплектующего',
  'Please enter the maximum GPS speed value at which the coordinates will be considered valid. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history.': 'Укажите максимальное значение скорости по GPS, при котором координаты будут считаться валидными. Фильтрация применяется только на онлайн сообщения для предотвращения выбросов и фиксации объекта на карте по последним валидным координатам. В истории сообщений сохраняются фактические координаты, присланные оборудованием.',
  'Please note that this functionality is intended exclusively for courier-type business models. In case of leaving a speed limit geofence, a general speed limit command of the region will be sent to devices':
    'Обращаем ваше внимание, что данный функционал предназначен исключительно для бизнес-модели курьерского типа. При выезде из геозоны ограничения скорости, на устройства будет отправляться команда общего ограничения скорости в регионе',
  'Power reserve': 'Запас хода',
  'Power reserve (km)': 'Запас хода (км)',
  'Previously Balance': 'Прежний баланс',
  Price: 'Цена',
  'Price 1': 'Цена 1',
  'Price 2': 'Цена 2',
  'Price 3': 'Цена 3',
  'Price 4': 'Цена 4',
  'Price in currency': 'Цена в валюте',
  'Price per unit': 'Цена за объект',
  'Price plan': 'Тариф',
  'Price plan creation': 'Создание тарифного плана',
  'Price plans': 'Тарифы',
  'Price plan count': 'Количество тарифных планов',
  'Price plan type': 'Тип тарифа',
  'Price plan preview': 'Превью тарифа',
  'Price plan can be assigned either to all objects of a specific user, or to all objects of a certain model, or to specific objects. To display the selection field for the desired destination, you must select the type of destination.':
    'Тариф можно назначить либо на все объекты конкретного пользователя, либо на все объекты определенной модели, либо на конкретные объекты. Для отображения поля выбора необходимого назначения необходимо выбрать тип назначения.',
  Priority: 'Приоритет',
  Process: 'Процесс',
  Profile: 'Профиль',
  Project: 'Проект',
  'Profile photo': 'Фотография профиля',
  'Project Country': 'Страна',
  'Project Name': 'Проект',
  'Project countries': 'Страны',
  Projects: 'Проекты',
  'Promo code': 'Промокод',
  'Promo code copied to clipboard': 'Промокод скопирован в буфер обмена',
  'promotions-and-news-publish-description':
    'Перед публикацией рекомендуем повторно проверить всю информацию.' +
    ' В случае редактирования уже опубликованной новости публикация будет снята автоматически' +
    ' и переведена в статус “Подготовлена” для повторной публикации.',
  'promotions-and-news-remove-from-publication-description':
    'Новость больше не будет доступна клиентам, но сохранится в вашем списке новостей.' +
    ' В случае необходимости повторной публикации необходимо отредактировать новость,' +
    ' после чего новость будет автоматически переведена в статус “Подготовлена” для повторной публикации.',
  'UID code copied to clipboard': 'UID скопирован в буфер обмена',
  Prohibited: 'Запрещена',
  Published: 'Опубликовано',
  Publish: 'Опубликовать',
  'Push history': 'История push-уведомлений',
  'Push notifications': 'Push-уведомления',
  'Push notification': 'Push-уведомление',
  'Push broadcast': 'Рассылка push-уведомлений',
  'Push notification text for client': 'Текст push-уведомления для клиента',
  'Push notification text': 'Текст push-уведомления',
  'Push notification to send when user has free cancellations left': 'Push-уведомление о количестве оставшихся бесплатных отмен',
  'Push notification to send when booking is paid': 'Push-уведомление при платном бронировании',
  'Push notification translations': 'Переводы push-уведомления',
  Pinned: 'Закреплена',
  'Not pinned': 'Не закреплена',
  'Pin news': 'Закрепить новость',
  'Pinned post': 'Закрепленная запись',
  'Rapid message delivery service': 'Сервис оперативной доставки сообщений',
  Rate: 'Тариф',
  'Rate of cancellation': 'Процент отмен',
  'Rates for subscriptions': 'Тарифы для абонементов',
  Rates: 'Тарифы',
  'Ready to order': 'Готово для заказа',
  'Region Name': 'Название региона',
  Reason: 'Причина',
  Refresh: 'Обновить',
  Refunds: 'Возвраты',
  Refund: 'Возврат',
  'Refunds(bank)': 'Возвраты(банковские)',
  'Amount to cancel': 'Сумма отмены',
  Region: 'Регион',
  Regions: 'Регионы',
  'Registration date': 'Дата регистрации',
  'Registration number': 'Регистрационный номер',
  'Registration number\'s numeric part': 'Числовая часть регистрационного номера',
  'Enter registration number\'s numeric part': 'Введите числовую часть регистрационного номера',
  'Registration status in the system': 'Статус регистрации в системе',
  'Reg. number': 'Рег. номер',
  'Reg. number not specified': 'Рег. номер не задан',
  Remove: 'Удалить',
  'Remove translate': 'Удалить перевод',
  Removed: 'Удалено',
  'Remove document': 'Удалить документ',
  'Remove from publication': 'Снять с публикации',
  'Removed from publication': 'Снято с публикации',
  'Rent from integrator to integrator': 'Передано в аренду от интегратора к интегратору',
  'Rent to integrator': 'Передано в аренду интегратору',
  'Repeat password': 'Повторите пароль',
  'Repeat the previously entered password to confirm the match.': 'Повторите введенный ранее пароль для подтверждения соответствия.',
  Repeaters: 'Ретранслятор',
  Replenishment: 'Пополнение',
  'repeater-enabled': 'Включен',
  'region-boundaries-info-text': 'Воспользуйтесь инструментами карты, чтобы отрисовать границы региона. По факту соединения точек нажмите “Сохранить”',
  Protocol: 'Протокол',
  Port: 'Порт',
  'Enable repeater for all units matching filter': 'Включить ретрансляцию для всех объектов, удовлетворяющих фильтру',
  'Disable repeater for all units matching filter': 'Отключить ретрансляцию для всех объектов, удовлетворяющих фильтру',
  'repeating-enabled': 'Вкл',
  'Repeater information': 'Сведения о ретрансляторе',
  'For courier shifts': 'Для смен курьеров',
  'For shifts': 'Для смен',
  'Select protocol': 'Выберите протокол',
  'Select unit assignment type': 'Выберите тип назначения объектов',
  Reports: 'Отчеты',
  Request: 'Запрос',
  'Requests in progress': 'В работе',
  'Required driver experience, years': 'Требуемый стаж вождения, лет',
  'Required driver age': 'Требуемый возраст водителя',
  'Required field': 'Обязательное поле',
  'Required step': 'Обязательный шаг',
  'Required to fill out': 'Обязательно к заполнению',
  'Required question': 'Обязательный вопрос',
  'Reservation info': 'Информация о бронировании',
  Reset: 'Сброс',
  'Residence address': 'Адрес места жительства',
  Response: 'Ответ',
  'Restart SIM': 'Перезапуск SIM',
  'Restrict by unit types and models': 'Ограничить по типу и модели объекта',
  Results: 'Результаты',
  'Returning clients': 'Вернувшиеся клиенты',
  Revenue: 'Выручка',
  Riding: 'Едет',
  Role: 'Роль',
  'Route points': 'Точки маршрута',
  'Routes purchases': 'Покупки маршрутов',
  Satellites: 'Спутники',
  'Satellites not found': 'Спутники не найдены',
  Save: 'Сохранить',
  Saved: 'Сохранено',
  Schedule: 'Расписание',
  'New schedule': 'Новое расписание',
  'Existing schedule': 'Существующее расписание',
  'Name of new schedule': 'Название нового расписания',
  'Enter name of new schedule': 'Введите название нового расписания',
  'Select schedule': 'Выберите расписание',
  'Geofence schedule': 'Расписание геозон',
  'Price plan schedule': 'Расписание тарифов',
  'schedule-plan': 'Запланировать',
  'Schedule templates': 'Шаблоны расписания',
  'Schedule template': 'Шаблон расписания',
  'Schedule is enabled': 'Расписание включено',
  'schedule changes in payment terms at the end of the current billing period':
    'запланировать изменения условий оплаты по окончании текущего расчётного периода',
  'Scope of assessment': 'Область оценки',
  Scooter: 'Самокат',
  Scooters: 'Самокаты',
  'Send a command': 'Отправить команду',
  'Send command "Disable service mode"': 'Отправить команду "Выключить сервисный режим"',
  'Send command "Enable service mode"': 'Отправить команду "Включить сервисный режим"',
  'Send command to unit': 'Отправить команду',
  'Send push notification to client': 'Отправить push-уведомление клиенту',
  'Send push notification': 'Отправить push-уведомление',
  'Send push notification to client after registration': 'Отправить push-уведомление клиенту после регистрации',
  'Send a notification to the client about the level change': 'Отправлять уведомление клиенту об изменении уровня',
  'Use balance payment method only for orders': 'Оплата заказов только по балансу',
  'Automatic balance replenishment': 'Автопополнение баланса',
  'Auto top-up disabled': 'Автопополнение баланса выключено',
  'Auto top-up enabled': 'Автопополнение баланса включено',
  'Automatic data substitution templates:': 'Шаблоны автоподстановки данных:',
  'Send to all clients': 'Отправить всем клиентам',
  'Sender name': 'Имя отправителя',
  'Serial number': 'Серийный номер',
  'Serial numbers': 'Серийные номера',
  'Serial / State number': 'Серийный / Гос. номер',
  'Server Error': 'Ошибка Сервера',
  'Server error': 'Ошибка сервера',
  'Service ID': 'ID услуги',
  Operation: 'Операция',
  Commission: 'Комиссия',
  'Service mode': 'Сервисный режим',
  SM: ' CP',
  'Service enabled': 'Сервис включен',
  'Service is online': 'Сервис работает',
  'Service requests': 'Заявки',
  'Service request': 'Заявка',
  'Service prices': 'Цены на услуги',
  Service: 'Услуга',
  Services: 'Услуги',
  'Service 1': 'Услуга 1',
  'Service 2': 'Услуга 2',
  'Service 3': 'Услуга 3',
  'Service 4': 'Услуга 4',
  'Services in progress': 'Заявки в работе',
  'Setting up events': 'Настройка событий',
  'Setting up the sender of email notifications': 'Настройка отправителя Email оповещений',
  'Setting up Telegram Gateway': 'Настройка Telegram Gateway',
  'Setting up Captcha': 'Настройка Captcha',
  'Set the speed limit disable command': 'Установить команду отключения ограничения скорости',
  'Set a schedule': 'Установить расписание',
  Show: 'Показать',
  'Shopping service - for buying bonus packages, routes, season tickets, travel cards':
    'Сервис покупок - для покупки бонусных пакетов, маршрутов, абонементов, проездных',
  'Short description': 'Краткое описание',
  'Show in mobile application': 'Показывать в мобильном приложении',
  'Show unit in application': 'Показать объект в мобильном приложении',
  'Show units in mobile application': 'Показывать объекты в мобильном приложении',
  'show-in-application': 'Виден',
  'Show-in-application': 'Виден',
  'Show units only on visible map area': 'Показывать только объекты в видимой области',
  'Show geofences': 'Показать геозоны',
  'Hide geofences': 'Спрятать геозоны',
  'Show region': 'Показать регион',
  'Hide region': 'Спрятать регион',
  'Only on visible map area': 'Только в видимой области',
  'Signal off': 'Выкл. звук. сигнал',
  'Signal on': 'Вкл. звук. сигнал',
  'Siren on': 'Сирена включена',
  'Siren off': 'Сирена выключена',
  'SIM Balance': 'Баланс SIM',
  'Simple registration': 'Простая регистрация',
  'Signing text': 'Текст подписания',
  Simple: 'Простая',
  'SMS Gateway': 'SMS-шлюзы',
  'Sms template must include [[code]] placeholder': 'Шаблон SMS должен включать текст [[code]]',
  'SMTP Mail Host': 'Почтовый хост SMTP',
  'SMTP server port': 'Порт SMTP-сервера',
  'Sorting priority': 'Приоритет сортировки',
  Sort: 'Сортировка',
  Spacious: 'Просторный',
  Speed: 'Скорость',
  'Speed limit': 'Ограничение скорости',
  'Speed limit command': 'Команда ограничения скорости',
  'Speed limit geofences': 'Геозоны ограничения скорости',
  Start: 'Начать',
  'Start time': 'Время начала',
  'Start checking': 'Начать проверку',
  'Start of the billing period': 'Начало расчётного периода',
  'Start of order': 'Начало заказа',
  'Start shift': 'Начать смену',
  State: 'Состояние',
  Status: 'Статус',
  'Date of blocking': 'Дата блокировки',
  'status-last-order-finish-time-perfect': 'менее 8 часов',
  'status-last-order-finish-time-ok': 'от 8 до 16 часов',
  'status-last-order-finish-time-warning': 'от 16 до 24 часов',
  'status-last-order-finish-time-alarm': 'более 24 часов',
  Step: 'Шаг',
  'Steps of registration': 'Этапы прохождения регистрации',
  Statistic: 'Статистика',
  'Subscription fee': 'Абонентская плата',
  Subscriptions: 'Абонементы',
  Subscription: 'Абонемент',
  'Subscription status': 'Состояние абонемента',
  'Such value already exists in this project': 'Такое значение уже используется в этом проекте',
  'Sum of transactions': 'Сумма по транзакциям',
  'Sum of geofences': 'Сумма геозон',
  'Suspicious customer': 'Подозрительный клиент',
  'Suspicious clients': 'Подозрительные клиенты',
  Summary: 'Итого',
  Supply: 'Спрос',
  Support: 'Помощь',
  Superuser: 'Суперпользователь',
  'Support contacts': 'Контакты техподдержки',
  'Successful transactions': 'Успешные транзакции',
  'Sum of all successful banking transactions for the selected period': 'Сумма всех успешных банковских транзакций за выбранный период',
  'Sum of all bonuses provided for the selected period': 'Сумма всех предоставленных бонусов за выбранный период',
  'Sum of arrears on orders and fines for the selected period': 'Сумма задолженностей по заказам и штрафам за выбранный период',
  'Sum of the value of orders for the selected period': 'Сумма стоимости заказов за выбранный период',
  Target: 'Цель',
  'Target type': 'Тип цели',
  'Tariff settings': 'Настройка тарифов',
  Demand: 'Спрос',
  'Use this tariff only at a certain level of demand': 'Использовать тариф только при определённом уровне спроса',
  'Use Google Hybrid': 'Использовать Google Hybrid',
  'Use GoMap.Az': 'Использовать GoMap.Az',
  'Minimum demand, percent': 'Минимальный спрос, %',
  'Maximum demand, percent': 'Максимальный спрос, %',
  'Minimum demand': 'Минимальный спрос',
  'Maximum demand': 'Максимальный спрос',
  Tasks: 'Задания',
  'Balance changing': 'Изменение баланса',
  'Activate to provide access to the functionality of manual changing the client\'s balance.':
    'Активируйте, чтобы предоставить доступ к функционалу ручного изменения баланса клиента',
  'Promocode creating': 'Создание промокодов',
  'Select a promocode project.': 'Выберите проект, для которого создается промокод.',
  'Select the project country in which the promo code will be applied.': 'Выберите страну проекта, в которой будет применяться промокод.',
  'Specify the owner of the promo code.': 'Укажите владельца промокода.',
  'Enter the promo code using numbers and capital letters without spaces or special characters.':
  'Введите промокод, используя цифры и заглавные буквы без пробелов и спецсимволов.',
  'The description of the promo code is used for administrative purposes and is not available to clients.':
  'Описание промокода используется в административных целях и не доступно конечным клиентам.',
  'If the promo code is intended for activation in all regions of the country, select type Country. If the promo code can be activated only in certain regions of the country, to be able to specify required regions, select type Regions.':
  'Если промокод предназначен для активации во всех регионах страны, выберите тип Страна. Если промокод можно активировать только в отдельных регионах страны, для получения возможности указать необходимые регионы, выберите тип Регионы.',
  'If the property doesn\'t have a cable lock, select "No Lock." When selecting a mechanical lock, the lock code will be displayed in the client\'s mobile app so the client can unlock it. The lock code is set in the settings for each unit. When selecting an electromechanical lock, the client\'s mobile app will allow the lock to be opened by sending a command for N seconds. Important: When the order completion screen is reached, the command to open the lock is sent automatically. This logic is not suitable for all types of electromechanical locks.': 'Если у объекта нет тросового замка, выберите тип «Без замка». При выборе механического замка в клиентском мобильном приложении отобразится код замка, чтобы клиент мог отстегнуть замок. Код замка прописывается в настройках каждого объекта. При выборе электромеханического замка в клиентском мобильном приложении будет доступен функционал открытия замка путем отправки команды на N количество секунд. Важно: при переходе на экран завершения заказа команда на открытие замка отправляется автоматически. Данная логика работы подходит не для всех типов электромеханических замков.',
  'If the property has a removable battery, select the "Removable Battery" type. The battery compartment lock status will be displayed in the property card. If the unit doesn\'t have a removable battery, select "Non-removable Battery."': 'Если объект оснащен съемным АКБ, укажите тип «Съемный АКБ». В карточке объекта появится отображение состояния замка деки АКБ. Если объект не оснащен съемным АКБ, укажите «Несъемный АКБ».',
  'If the hardware does not transmit the battery charge level, or the hardware transmits the value, but due to the specifics of its operation, the readings are incorrect, you can change the calculation method by specifying, for example, the voltage parameter and specifying the values of this parameter for a 0% charge level and a 100% charge level.': 'Если оборудование не передает уровень заряда АКБ, или же оборудование передает значение, но из-за специфики работы показатели некорректные, вы можете изменить метод вычисления заряда, указав, например, параметр напряжения и указать значения данного параметра для нулевого уровня заряда и 100% уровня заряда.',
  'Specify the regions in which clients can activate the promo code.': 'Укажите регионы, в которых клиенты смогут активировать промокод.',
  'Specify the language in which the news should be displayed if there is no translation corresponding to the language of the client\'s device.':
    'Укажите на каком языке необходимо отображать новость, в случае отсутствия перевода, соответствующего языку устройства клиента.',
  'A client can activate a promo code once. Specify the maximum number of clients who can activate promo code.':
  'Клиент может активировать промокод один раз. Укажите максимальное количество клиентов, которые могут активировать промокод.',
  'Enter the promo code amount in the country\'s currency. When promo code is activated, the specified amount will be credited to the client\'s balance.':
  'Введите сумму промокода в валюте страны. При активации промокода указанная сумма будет зачислена на баланс клиента.',
  'Enter a name for the geofence. We recommend using geofence type name and, for example, an address, so you can quickly find the geofence in the list if needed.': 'Укажите название геозоны. Рекомендуем в названии использовать название типа геозоны и, например, адрес, чтобы при необходимости можно было быстро найти геозону в списке.',
  'Specify the start date of the promo code. The promo code can\'t be activated before the start date.':
  'Укажите дату начала периода действия промокода. Активация промокода недоступна до начала периода действия.',
  'Specify the expiration date of the promo code. Promo code activation is not available after expiration date. Leave the field blank if the promo code has no expiration date.':
  'Укажите дату окончания периода действия промокода. После окончания периода действия активация промокода недоступна. Если период действия промокода неограничен, оставьте поле пустым.',
  'Specify the icon owner. The icon owner, as well as their child users with editing permissions, will be able to edit and delete the icon.': 'Укажите владельца иконки. Владелец иконки, а также его дочерние пользователи с правами на редактирование, смогут редактировать и удалять иконку.',
  'Specify the schedule owner. The schedule owner, as well as their child users with editing permissions, will be able to edit and delete the schedule.': 'Укажите владельца расписания. Владелец расписания, а также его дочерние пользователи с правами на редактирование, смогут редактировать и удалять расписание.',
  'Enter the sum': 'Введите сумму',
  'Activate to provide access to the functionality of creating promocodes.':
    'Активируйте, чтобы предоставить доступ к функционалу создания промокодов.',
  'Technical support': 'Техническая поддержка',
  'Text of push notification after registration': 'Текс пуш-уведомления после регистрации',
  'These condition types cannot be combined': 'Выбранные типы условий в уведомлении нельзя комбинировать',
  'The name of the subscription will be displayed in the mobile application. You can use emoji for emphasis':
    'Название абонемента будет отображаться в мобильном приложении. Можно использовать emoji для акцентирования внимания',
  'The subscription will be available only to the specified testers.':
    'Абонемент будет доступен только указанным клиентам-тестировщикам.',
  'The validity period of the subscription condition is specified in days. 1 day = 24 hours.':
    'Период действия условия абонемента задается в днях. 1 день = 24 часам.',
  'The condition with the minimum cost is marked to display the minimum cost of the subscription in the mobile application':
    'Отмечается условие с минимальной стоимостью для отображения минимальной стоимость абонемента в мобильном приложении',
  'The name of the tariff will be displayed in the mobile application both in the tariff preview of the tariff list and in the detailed tariff card.':
    'Название тарифа будет отображаться в мобильном приложении как в превью тарифа списка тарифов , так и в подробной карточке тарифа. ',
  'The country of the project in which the tariff will be presented is indicated':
    'Указывается страна проекта, в которой будет представлен тариф',
  'The regions in which the tariff will be presented are indicated':
    'Указываются регионы, в которых будет представлен тариф ',
  'The currency in which the prices will be presented is indicated':
    'Указывается валюта, в которой будут представлены цены тарифа',
  'The owner of the tariff is indicated. The owner will be given the opportunity to manage the tariff':
    'Указывается владелец тарифа. Владельцу будет предоставлена возможность управлением тарифом',
  'The owner of the subscription is indicated. The owner will be given the opportunity to manage the subscription':
    'Указывается владелец абонемента. Владельцу будет предоставлена возможность управлять абонементом',
  'The name of the charged service is indicated, for example, Trip start, Trip, Pause, etc. The name of the service is displayed in the fare card in the mobile application':
    'Указывается название тарифицируемой услуги, например, Старт поездки, Поездка, Пауза и др. Название услуги отображается в карточке тарифа в мобильном приложении',
  'The price of service 1 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Указывается цена услуги 1, например, 10 руб., 5 руб/мин, 300 руб/час и т.д.',
  'The price of service 2 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Указывается цена услуги 2, например, 10 руб., 5 руб/мин, 300 руб/час и т.д.',
  'The price of service 3 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Указывается цена услуги 3, например, 10 руб., 5 руб/мин, 300 руб/час и т.д.',
  'The price of service 4 is indicated, for example, 10 rubles, 5 rubles / min, 300 rubles / hour, etc.':
    'Указывается цена услуги 4, например, 10 руб., 5 руб/мин, 300 руб/час и т.д.',
  'The cost of insurance is indicated in an arbitrary format, indicating the currency, for example, 35 rubles. In the specified form, the cost of insurance will be displayed in the mobile application.':
    'Указывается стоимость страховки в произвольном формате с указанием валюты, например, 35 руб. В указанном виде стоимость страховки будет отображаться в мобильном приложении.',
  'The insurance description is displayed in the mobile application on a separate screen. Each paragraph is displayed with a bullet. The description must contain the sums insured':
    'Описание страховки отображается в мобильном приложении на отдельном экране. Каждый абзац отображается с маркером. В описании должны присутствовать суммы страхования',
  'The internal name is displayed only in the admin panel and is not available to clients in the mobile app.': 'Внутреннее название отображается только в панели администратора и недоступно клиентам в мобильном приложении',
  'The minimum battery charge of the object is specified, at which the tariff can be displayed in the mobile application for the object.':
    'Указывается минимальный заряд АКБ объекта, при котором можно отображать тариф в мобильном приложении для объекта.',
  'The name of the object will be displayed in the client interface in the object card':
    'Название объекта будет отображаться в интерфейсе клиента в карточке объекта',
  'The serial number or the state number depending on the selected object type is indicated. This information is only displayed in the admin panel.':
    'Указывается серийный номер или государственный номер в зависимости от выбранного типа объекта. Данная информация отображается только в панели администратора.',
  'The object status depends on the availability of the object in the client application, the activity of the hardware service mode, etc. Please, pay attention that when the object is set to "Available" status, subscription fee for the object in the current month is activated. We recommend not to transfer object to the status "Accessible" before full adjustment and check of the equipment functioning!':
    'От статуса объекта зависит доступность объекта в клиентском приложении, активность аппаратного сервисного режима и др. Обращаем ваше внимание, что при переводе объекта в статус «Доступен» активируется абонентская плата за объект в текущем месяце. Рекомендуем не переводить объект в статус «Доступен» до полной настройки и проверки функционирования оборудования!',
  'The integrator\'s client is considered to be the person who has placed the order for the integrator\'s unit. Client in a region is considered to be the person who has placed the order for the integrator\'s unit in a specific region.': 'Клиент интегратора определяется по наличию заказа объекта у интегратора. Клиент в регионе определяется по наличию заказа объекта у интегратора в конкретном регионе.',
  'The number must be greater than 0': 'Число должно быть больше 0',
  'The number must not be less than 0': 'Число не может быть меньше 0',
  'The number must not exceed the limit': 'Число не может превышать лимит',
  'The number must not be more than': 'Число не может быть больше',
  'Field value must be non-negative number': 'Значение поля должно быть неотрицательным числом',
  'The number must be an integer': 'Число должно быть целым',
  'The name of the organization is used in acceptance certificates and other documents. Specify the name of the organization in the format LLC "Ivanov", SE Ivanov Ivan Ivanovich.':
    'Название организации используется в актах приема-передачи и других документах. Укажите название организации в формате ООО «Иванов», ИП Иванов Иван Иванович.',
  'Time interval is incorrect': 'Некорректный интервал времени',
  'The first 6 digits of the card': 'Первые 6 цифр карты',
  'The last 4 digits of the card': 'Последние 4 цифры карты',
  'The subscription will be activated for the group\'s clients upon turning on the subscription by the user. Specify the expiration date of the subscription, upon which the subscription will be deactivated for group clients.':
    'Абонемент будет активирован клиентам группы по факту включения абонемента пользователем. Укажите дату истечения срока действия абонемента, при наступлении которой абонемент будет деактивирован у клиентов группы.',
  'The image must be in PNG or JPEG format. The aspect ratio must be 16:9 for correct display.':
    'Изображение должно быть в формате PNG или JPEG. Для корректного отображения соотношение сторон должно составлять 16:9.',
  'The image must be in PNG or JPEG format. The aspect ratio must be 1:1 for correct display. Recommended resolution is 300px * 300px':
    'Изображение должно быть в формате PNG или JPEG. Для корректного отображения соотношение сторон должно составлять 1:1. Рекомендуемое разрешение 300px * 300px.',
  'The client\'s activity level is assessed daily. The assessed activity period is the last 30 days. One of 2 criteria is used for assessment: order value or order duration. When selecting the assessment criterion by order value, the amount of paid orders in the country\'s currency required to achieve the level. This takes into account payments both by balance and by bank card. When selecting the assessment criterion by order duration, the total duration of all completed orders over the last 30 days required to achieve the level.':
    'Оценка уровня активности клиента осуществляется ежедневно. Оцениваемый период активности – последние 30 дней. Для оценки используется один из 2-х критериев: стоимость заказов или длительность заказов.\n' +
    'При выборе критерия оценки по стоимости заказов указывается необходимая для достижения уровня сумма оплаченных заказов в валюте страны. При этом учитываются оплаты как по балансу, так и по банковской карте. При выборе критерия оценки по длительности заказов указывается необходимая для достижения уровня общая длительности всех завершенных заказов за последние 30 дней.',
  'The amount of paid orders in the country\'s currency required to achieve the level': 'Указывается необходимая для достижения уровня сумма оплаченных заказов в валюте страны',
  'The total duration of all completed orders over the last 30 days required to achieve the level.':
    'Указывается необходимая для достижения уровня общая длительности всех завершенных заказов за последние 30 дней.',
  'The opening of the office means that the office is ready to process requests for services provided and will be available in the mobile application for couriers.':
    'Открытие офиса означает, что офис готов к обработке заявок на оказываемые услуги и будет доступен в мобильном приложении для курьеров.',
  'The hardware model name is unique within the system. Therefore, to avoid errors, it is recommended to add the project name or other unique identifying characteristics to the name. The name may only contain letters, numbers, hyphens, and underscores.': 'Название модели оборудования является уникальным в системе. Поэтому, во избежание ошибки, рекомендуется добавлять к названию название проекта или же другие уникальные отличительные признаки. Название может содержать только буквы, цифры, дефисы и знаки подчеркивания',
  'This subscription can have only one condition': 'У данного абонемента может быть только одно условие',
  'There are not enough funds on the balance of the personal account. The objects are hidden and are not available for rent to clients. In order to resume the service it is necessary to replenish the balance of the personal account.':
  'На балансе лицевого счета недостаточно денежных средств. Объекты скрыты и недоступны для аренды клиентам. Для возобновления обслуживания необходимо пополнить баланс лицевого счета.',
  'There is a debt on the balance of your personal account. To avoid blocking the account, you must pay the debt before the deadline.': 'На балансе лицевого счета образовалась задолженность. Во избежание блокировки учетной записи необходимо погасить задолженность до наступления крайнего срока.',
  'There are two subtypes available for the "Finish Allowed" geofence: Simple and Bonus. "Simple" geofences are used to specify the area where the order can be completed. "Bonus" geofences are used to automatically credit bonuses to the client\'s balance upon completion of the trip. Important: the bonus will only be credited to the client\'s balance after full payment.': 'Для геозоны типа «Финиш разрешен» доступно 2 подтипа: Простая и Бонусная. Простая предназначена только для указания области, в которой можно завершить аренду. Бонусная предназначена для автоматического зачисления бонусов на баланс клиента в приложении по завершению поездки. Важно: бонус будет зачислен клиенту на баланс только при полной оплате заказа.',
  Time: 'Время',
  Timezone: 'Часовой пояс',
  'Time interval (hours)': 'Интервал времени (часов)',
  'Time of closing': 'Время закрытия',
  'Time of operation': 'Время операции',
  'Time period': 'Период времени',
  'The time allocated for verification is coming to an end. To reset the timer and continue checking documents, enter the password again.':
    'Выделенное для проверки время подходит к концу. Чтобы сбросить таймер и продолжить проверку документов, введите пароль повторно.',
  'Title image': 'Титульное изображение',
  Today: 'Сегодня',
  'Toggle fullscreen': 'Включить полноэкранный режим',
  Total: 'Всего',
  'Total mileage': 'Общий пробег',
  'Total cost (orders)': 'Суммарное расстояние',
  'Total distance': 'Суммарное расстояние',
  'Total duration': 'Суммарная длительность',
  'Total order count': 'Всего заказов',
  'Total price': 'Общая цена',
  'Total price (orders)': 'Суммарная стоимость заказов',
  'Total successful order duration': 'Длительность успешных заказов',
  'to change the payment terms in the current billing period upon saving the changes, as well as to recalculate the data from the beginning of the billing period to the moment of making changes.':
    'внести изменение условий оплаты в текущем расчётном периоде по факту сохранения изменений, а также произвести перерасчёт данных с момента начала расчётного периода до момента внесения изменений.',
  'To be able to configure telegram alerts for the notifications created in the system, specify the API key of the telegram bot.':
    'Для получения возможности настройки телеграм-оповещений по созданным уведомления в системе, укажите API-key телеграм бота.',
  'To gain access to the extended registration document check, you must enter the moderator\'s password. Access will be available for 9 hours from the moment of entering the password. After the time expires, you must re-enter the password to continue the verification.':
    'Для получения доступа к проверке документов расширенной регистрации необходимо ввести пароль модератора. Доступ будет открыт в течение 9-ти часов с момента ввода пароля. По истечении времени для продолжения проверки необходимо ввести пароль повторно.',
  'To have access to check advanced registration documents, user have to enter the moderator password.':
    'Для получения доступа к проверке документов расширенной регистрации пользователю необходимо ввести пароль модератора.',
  'To highlight the news on the main screen you can add a icon in SVG format measuring 24 x 24 pixels. Adding an icon is not required. You can highlight the news by using emoji in the title.':
    'Чтобы выделить новость на главном экране вы можете добавить иконку размером 24 x 24 пикселя в формате SVG. Добавление иконки не является обязательным. Вы можете выделить новость используя emoji в заголовке.',
  'To automatically populate client, organization, and/or facility information in a document, use the following templates. To quickly copy a template, click it once.': 'Для автоматической подстановке данных клиента, организации и/или объекта в документе используйте следующие шаблоны. Для быстрого копирования шаблона кликните на него один раз.',
  Trailers: 'Прицепы',
  Trailer: 'Прицеп',
  'Trailer price': 'Цена прицепа',
  'Track time': 'Время трека',
  Tracker: 'Трекер',
  'Tracker price': 'Цена трекера',
  'Tracker charge': 'Заряд трекера',
  Trackers: 'Трекеры',
  'IoT modules': 'IoT-модули',
  'Mechanical bicycles': 'Механические велосипеды',
  'Electric bicycles (without IoT)': 'Электровелосипеды (без IoT)',
  'Electric bicycles (with IoT)': 'Электровелосипеды (c IoT)',
  'Snow scooters': 'Электроснегокаты',
  Trikes: 'Трайки',
  'Tracker connection': 'Подключение трекера',
  'Battery connection': 'Подключение батареи',
  'Monitoring module': 'Модуль мониторинга',
  'Transaction was successfully canceled': 'Транзакция успешно отменена',
  Transactions: 'Транзакции',
  'Transactions by bank cards': 'Транзакции по банковской карте',
  'Transaction amount': 'Сумма операции',
  'Transaction status': 'Статус операции',
  'Receipt status': 'Статус чека',
  'Translation of push notification after registration': 'Перевод пуш-уведомления после регистрации',
  Translations: 'Переводы',
  'Translate into other languages': 'Перевести на другие языки',
  Transmission: 'Коробка передач',
  'Transferred for temporary use': 'Передан во временное пользование',
  'Transfer to access': 'Перевести в доступ',
  'Translation language': 'Язык перевода',
  Tricycle: 'Трицикл',
  'Tricycle price': 'Цена трицикла',
  Tricycles: 'Трициклы',
  'Trigger conditions': 'Условия срабатывания',
  Trips: 'Поездки',
  Trip: 'Поездка',
  Type: 'Тип',
  Subtype: 'Подтип',
  'Type of allocation': 'Тип размещения',
  'Type of transport': 'Тип транспорта',
  'Type of geofence': 'Тип геозоны',
  'Unblock device': 'Разбл. устройство',
  'Unblock engine': 'Разбл. двигатель',
  'Unique name': 'Уникальное имя',
  Unit: 'Объект',
  'Unit address': 'Адрес объекта',
  'Unit coord': 'Координаты объекта',
  Hardware: 'Оборудование',
  'Unit billing type': 'Тип биллинга для объекта',
  'Unit commands': 'Команды',
  'Unit images': 'Фотографии объекта',
  'Unit notification log': 'Журнал по объектам',
  'Unit notifications settings': 'Настройка уведомлений по объектам',
  'Unit state': 'Состояние объекта',
  'Unit status change': 'Изменение статуса объекта',
  'Unit status': 'Статус объекта',
  'Unit type': 'Тип объекта',
  'Unit model': 'Модель объекта',
  'Unit models': 'Модели объектов',
  'Unit model groups': 'Группы моделей объектов',
  'Unit replacement': 'Замена объекта',
  Units: 'Объекты',
  units: 'объектов',
  'Units offline': 'Объекты в автономном режиме',
  'Unit count': 'Количество объектов',
  'Unit location': 'Местоположение объекта',
  'Location on map': 'Местоположение на карте',
  'Type of component' : 'Тип комплектующего',
  'Select type of component' : 'Выберите тип комплектующего',
  'Unique identifier': 'Уникальный идентификатор',
  'Until the next maintenance, km': 'До следующего ТО, км',
  Unlimited: 'Безлимит',
  unlimited: 'Неограниченно',
  'Unknown server error': 'Неизвестная ошибка сервера',
  'Upper bound of the interval': 'Верхняя граница интервала',
  User: 'Пользователь',
  Username: 'Имя пользователя',
  'User blocked': 'Заблокирован',
  'User login': 'Логин пользователя',
  'User role': 'Роли пользователя',
  'Custom roles': 'Кастомные роли',
  'Custom role': 'Кастомная роль',
  'Select custom role': 'Выберите кастомную роль',
  'Type of role': 'Тип роли',
  'Select type of role': 'Выберите тип роли',
  'Base role': 'Базовая роль',
  'Select base role': 'Выберите базовую роль',
  'Automatically enable new features from future releases': 'Автоматически включать новые возможности из будущих релизов',
  'User activity log': 'Журнал действий пользователей',
  'Use by default': 'Использовать по умолчанию',
  Users: 'Пользователи',
  Usual: 'Обычный',
  'Valid from': 'Действителен С',
  'Valid to': 'Действителен По',
  'Valid until': 'Действителен до',
  'Validation error': 'Ошибка проверки',
  'Validation error - do you have order? Or order already finished?': 'Ошибка проверки - у вас есть заказ? Или заказ уже завершен?',
  Value: 'Значение',
  'Value in coins': 'Значение в монетах',
  'Value is too small': 'Значение слишком мало',
  'Invalid characters in promo code': 'Недопустимые символы в промокоде',
  'Invalid characters in registration number': 'Недопустимые символы в регистрационном номере',
  'Invalid coordinate filtering settings': 'Настройка фильтрации невалидных координат',
  'Please add insurance to price plan': 'Пожалуйста, добавьте страховку в тариф',
  'Please configure insurance only once': 'Пожалуйста, настройте страховку только один раз',
  'Please note that this functionality is intended exclusively for the courier business model. When leaving the speed limit geofence, the speed limit disable command set for the hardware model will be sent to the devices, unless a different command is specified in the location region settings for that hardware model.': 'Обращаем ваше внимание, что данный функционал предназначен исключительно для бизнес-модели курьерского типа. При выезде из геозоны ограничения скорости на устройства будет отправляться команда отключения ограничения скорости, установленная для модели оборудования, если в настройках региона местоположения объекта для данной модели оборудования не будет указана другая команда.',
  'Invalid insurance amount; valid amount is:': 'Указана некорректная стоимость страховки; корректная стоимость:',
  'Indicate country and city of birth': 'Укажите страну и город рождения',
  Videos: 'Видеофайлы',
  'Video link': 'Ссылка на видео',
  View: 'Просмотр',
  'View Profile': 'Просмотреть профиль',
  'View unit': 'Просмотреть объект',
  Viewed: 'Просмотрено',
  Warehouse: 'Склад',
  'Warehouse number': 'Номер склада',
  'Wait polygon': 'Ожидание полигона',
  'Waiting time': 'Время ожидания',
  Week: 'Неделя',
  'Weak signal': 'Слабый сигнал',
  'We recommend using no more than 35 characters, including spaces to ensure that the title is displayed correctly on various mobile devices':
    'Для корректного отображения заголовка на различных мобильных устройствах рекомендуем использовать не более 35 символов, включая пробелы',
  'We recommend using no more than 90 characters, including spaces to ensure that the title is displayed correctly on various mobile devices':
    'Для корректного отображения краткого описания на различных мобильных устройствах рекомендуем использовать не более 90 символов, включая пробелы',
  'Write the main content of the news': 'Напишите текст основного содержания новости',
  'Write a brief description. If a schedule is set for the geofence, we recommend including the geofence\'s operating hours in the description. If you\'re creating a speed limit geofence, also include the maximum speed limit.': 'Напишите краткое описание. Если для геозоны установлено расписание, рекомендуем указать в описании время работы геозоны. Если вы создаете геозону ограничения скорости, укажите также значение максимальной скорости.',
  'Write a brief description. If the geopoint matches the geofence logic, we recommend duplicating the information from the geofence logic description.': 'Напишите краткое описание. Если геоточка соответствует логике геозоны, рекомендуем продублировать информацию из описания логики геозоны.',
  Width: 'Ширина',
  'Width(mm)': 'Ширина(мм)',
  'Write off': 'Списать',
  'Write-off date': 'Дата списания',
  'Written off': 'Списано',
  'Write-off': 'Списание',
  'Write off property': 'Списать имущество',
  Yesterday: 'Вчера',
  admin: 'админ',
  booked: 'в брони',
  'color not set': 'цвет не задан',
  free: 'Свободен',
  Free: 'Свободен',
  gsm: 'GSM',
  'hw_id already exists': 'HW ID уже есть в системе',
  integrator: 'интегратор',
  more: 'подробнее',
  More: 'Подробнее',
  'no address': 'адрес не задан',
  'No new clients awaiting confirmation': 'Нет новых клиентов, ожидающих подтверждения',
  'not booked': 'не забронировано',
  'not set': 'не задано',
  'Not found': 'Не найдено',
  'Normal signal': 'Нормальный сигнал',
  'No customer data': 'Нет данных клиентов',
  'No data': 'Нет данных',
  role: 'роль',
  Images: 'Изображения',
  'Image size 300x300, in formats .png, .jpg, .jpeg, .svg.': 'Размер изображения 300x300, в формате .png, .jpg, .jpeg, .svg',
  'Payment methods': 'Способы оплаты',
  Payment: 'Оплата',
  Selected: 'Выбрана',
  Selection: 'Выбор',
  Select: 'Выбрать',
  'Select date': 'Выберите дату',
  'Select battery': 'Выберите батарею',
  'Freeze coordinates': 'Зафиксировать координаты объекта',
  'Activate if necessary to freeze coordinates of unit at a certain point. The coordinate input field and unit location on the map will appear after activation.' :
    'Активируйте в случае необходимости зафиксировать координаты объекта в определенной точке. Поле ввода кооридинат и отображение местоположения объекта на карте появится после активации.',
  'After reaching the level, upon successful payment and order finishing, the client will be awarded a reward in the form of cashback at a specified percentage of the order value. The specified reward will be credited to the client until the client\'s activity level changes.':
    'После достижения уровня при завершении и успешной оплаты заказов клиенту будет начисляться вознаграждение в виде кешбэка по указанному проценту от стоимости заказа. Указанное вознаграждение будет начисляться клиенту до тех пор, пока уровень активности клиента не изменится.',
  'Select contact type': 'Выберите тип контакта',
  'Select trackers': 'Выберите трекеры',
  'Select service type': 'Выберите услугу',
  'Select source': 'Выберите источник',
  'Select calculation method': 'Выберите метод',
  'Select billing model': 'Выберите порядок оплаты',
  'Select the track building period': 'Выберите период построения трека',
  'Select destination type': 'Выберите тип назначения',
  'Select document format': 'Выберите формат документа',
  'Select type': 'Выберите тип',
  'Select fare type': 'Выберите тип тарифа',
  'Select user': 'Выберите пользователя',
  'Select unit models': 'Выберите модели объектов',
  'Select objects': 'Выберите объекты',
  'Select owner': 'Выберите владельца',
  'Select one option': 'Выберите один вариант',
  'Select currency': 'Выберите валюту',
  'Select one default condition': 'Выберите одно условие по умолчанию',
  'Select testers': 'Выберите тестировщиков',
  'Select subscription type': 'Выберите тип абонемента',
  'Select regions': 'Выберите регионы',
  'Select region': 'Выберите регион',
  'Select price plans': 'Выберите тарифы',
  'Select price plan': 'Выберите тариф',
  'Select operating mode': 'Выберите режим работы',
  'Select test clients': 'Выберите клиентов-тестировщиков',
  'Select translation language': 'Выберите язык перевода',
  'Select language': 'Выберите язык',
  'Select license categories': 'Выберите категории прав',
  'Select unit type': 'Выберите тип объекта',
  'Select unit types': 'Выберите типы объектов',
  'Select a project': 'Выберите проект',
  'Select a country': 'Выберите страну',
  'Select a period': 'Выберите период',
  'Select period': 'Выберите период',
  'Select an event': 'Выберите событие',
  'Select actions': 'Выберите действия',
  'Select action': 'Выберите действие',
  'Select state': 'Выберите состояние',
  'Select a command pattern': 'Выберите шаблон команды',
  'Select a condition': 'Выберите условие',
  'Select a role': 'Выберите роль',
  'Select a technician': 'Выберите техника',
  'Select a speed limit': 'Выберите ограничение скорости',
  'Select section': 'Выбрать раздел',
  'Select group': 'Выберите группу',
  'Select groups': 'Выберите группы',
  'Select geofences': 'Выберите геозоны',
  'Select clients': 'Выберите клиентов',
  'Select level': 'Выберите уровень',
  'Select legal entity': 'Выберите юр. лицо',
  'Select branch office': 'Выберите филиал',
  'Select hw type': 'Выберите тип оборудования',
  'Select lock type': 'Выберите тип замка',
  'Select battery placement type': 'Выберите тип размещения АКБ',
  'Select command': 'Выберите команду',
  'Select the objects for which the tariff will be available':
    'Выберите объекты, для которых будет доступен тариф',
  'Select a model': 'Выберите модель',
  'Select the group of clients for whom you want to activate the subscription':
    'Выберите группу клиентов, для которых необходимо активировать абонемент',
  'Select price plans available within the subscription': 'Выберите тарифы доступные в рамках абонемента',
  'Select the language for which the subscription information translation will be added':
    'Выберите язык, для которого будет добавлен перевод информации об абонементе',
  'Select the language for which the price plan information translation will be added':
    'Выберите язык, для которого будет добавлен перевод информации о тарифе',
  'Select the region in which the subscription will be valid. If more than one region is selected, the client will be able to use the subscription in all specified regions.':
    'Выберите регион, в котором будет действовать абонемент. В случае выбора более одного региона, клиент сможет пользоваться абонементом во всех указанных регионах.',
  'Subscription type': 'Тип абонемента',
  'Select the type of object for which this subscription will be valid':
    'Выберите тип объекта, для которого будет действовать данный абонемент',
  'Create subscription': 'Создание абонемента',
  'Create fare': 'Создание тарифного плана',
  'Select the project that will apply this requirement':
    'Выберите проект, в котором будет действовать данный абонемент',
  'Select the project in which notifications will be sent': 'Выберите проект, в котором будет осуществляться рассылка уведомлений.',
  'Select the country in which notifications will be sent': 'Выберите страну, в которой будет осуществляться рассылка уведомлений.',
  'Select the integrator whose clients will receive notifications': 'Выберите интегратора, по клиентам которого будет осуществляться рассылка уведомлений.',
  'Select the region in which notifications will be sent': 'Выберите регион, в котором будет осуществляться рассылка уведомлений.',
  'Select the country in the project in which this subscription will be valid':
    'Выберите страну в проекте, в которой будет действовать данный абонемент',
  'Select the color to get the color code that you will later use in the client interface functionality.':
    'Выберите цвет для получения цветового кода, который будет в последствии использовать в функционале клиентского интерфейса.',
  'Select a role. (Administrator or Integrator)': 'Выберите роль. (Администратор или интегратор)',
  'Select a schedule from the list of schedules you have previously created.': 'Выберите расписание из списка ранее созданных вами расписаний.',
  'Select the action you intend to take with respect to the user\'s payment terms:':
    'Выберите действие, которое вы собираетесь совершить в отношении условий оплаты пользователя:',
  'Select connection method': 'Выберите метод подключения',
  'Select the battery registration status in the system': 'Выберите статус регистрации батареи в системе',
  'Select the status of the registration status in the system': 'Выберите статус статус регистрации в системе',
  'Select the unit to which the tracker connects.': 'Выберите объект, к которому подключается трекер.',
  'Select the removable battery that the tracker is connected to.': 'Выберите съемную батарею, к которой подключается трекер.',
  'Select the project where group of clients is created.': 'Выберите проект, в котором создается группа клиентов.',
  'Select the country of the project where group of clients is created.': 'Выберите страну проекта, в которой создается группа клиентов.',
  'Select the region where group of clients is created.': 'Выберите регион, в котором создается группа клиентов.',
  'Select the owner of group of clients.': 'Выберите владельца группы клиентов.',
  'Select the clients you want to assign to the group.': 'Выберите клиентов, которых необходимо назначить на группу.',
  'Select the group of clients for whom you want to activate the subscription.': 'Выберите группу клиентов, для которых необходимо активировать абонемент.',
  'Select the type of movement': 'Выберите тип передвижения',
  'Select the project for the component type you are creating': 'Выберите проект, в котором создается тип комплектующего',
  'Select the hardware model for which the speed limit command is being added': 'Выберите модель оборудования, для которой добавляется команда ограничения скорости.',
  'Select the speed limit command according to the selected hardware model': 'Выберите команду ограничения скорости, в соответствии с выбранной моделью оборудования',
  'Select the business-model for the geofence you are creating': 'Выберите бизнес-модель, для которой создается геозона',
  'Select employment type': 'Выберите тип занятости',
  'Select couriers': 'Выберите курьеров',
  'Select a courier': 'Выберите курьера',
  'Courier identification': 'Идентификация курьера',
  'Select courier identification': 'Выберите способ идентификации курьера',
  'External id of the courier': 'Внешний идентификатор курьера',
  'Select an assignment method': 'Выберите метод назначения',
  'Select form type': 'Выберите тип формы',
  'Select document type': 'Выберите тип документа',
  'Select the document addition method': 'Выберите метод добавления документа',
  'Select enrollment form': 'Выберите форму зачисления',
  'Select registration form': 'Выберите форму регистрации',
  'Select the country code': 'Выберите код страны',
  'Select authentication method': 'Выберите способ аутентификации',
  'Select a bag': 'Выберите сумку',
  'Select a time zone': 'Выберите часовой пояс',
  'Select the project for the news item you are creating': 'Выберите проект, в котором создается новость',
  'Select the country for the news item you are creating': 'Выберите страну, в которой создается новость',
  'Select criterion': 'Выберите критерий',
  'Select the project for the client\'s activity level you are creating':
    'Выберите проект, для которого создается уровень активности клиента',
  'Select the translation language of the client\'s activity level name':
    'Выберите язык, для которого будет добавлен перевод названия уровня активности клиента',
  'Select the project for the conditions you are creating':
    'Выберите проект, для которого добавляются условия достижения уровня активности клиента',
  'Select the country for the conditions you are creating':
    'Выберите страну, для которой добавляются условия достижения уровня активности клиента',
  'Select the business model for the conditions you are creating':
    'Выберите бизнес-модель, для которой добавляются условия достижения уровня активности клиента',
  'Select the client activity level for the achievement conditions you are creating':
    'Выберите уровень активности клиента, для которой добавляются условия достижения',
  'Select the project for the component model you are creating': 'Выберите проект, в котором создается модель комплектующего',
  'Select the project for the branch you are creating': 'Выберите проект, в котором создается филиал',
  'Select the country for the branch you are creating': 'Выберите страну, в которой создается филиал',
  'Select the project for the Legal Entity you are creating': 'Выберите проект, в котором создается юридическое лицо',
  'Select the country for the Legal Entity you are creating': 'Выберите страну, в которой создается юридическое лицо',
  'Select the hardware type that matches your device. The port the device should be pointed to is shown in brackets. If you can\'t find the right hardware type or need any other assistance setting up your device connection, please contact technical support.': 'Выберите тип оборудования, соответствующий вашему устройству. В скобках отображается порт, на который должен быть направлен девайс. Если вы не можете найти подходящий тип оборудования или же вам нужна любая другая помощь с настройкой подключения вашего устройства, обратитесь в службу технической поддержки.',
  'Select owner of the Legal Entity you are creating': 'Выберите владельца юридического лица',
  'Select region of the branch you are creating': 'Выберите регион, в котором создается филиал',
  'Select owner of the branch you are creating': 'Выберите владельца филиала',
  'Select unit type for the hardware model you are creating': 'Выберите тип объекта, для которого создается модель оборудования',
  'Select the speed limit disable command': 'Выберите команду отключения ограничения скорости',
  'Select the days of the week for your schedule': 'Выберите дни недели работы расписания.',
  'Specify group name. For example, LLC Delivery3000.': 'Укажите название группы клиентов. Например, ООО "Доставка 3000".',
  'Enter custom group name description.': 'Введите произвольное описание группы клиентов.',
  'Subscription period already selected': 'Выбранный период действия абонемента уже добавлен',
  'Subscription terms': 'Условия абонемента',
  'Subscription price is indicated for each validity period': 'Стоимость абонемента указывается для каждого периода действия',
  'subscription-fee-amount-value': 'Стоимость',
  'Subscription purchases': 'Покупки абонементов',
  Number: 'Номер',
  News: 'Новости',
  'Number of trips': 'Количество поездок',
  'Number of trips (-1 - Unlimited)': 'Количество поездок (-1 - Неограниченно)',
  'Add date': 'Дата добавления',
  'No bank cards': 'Нет банковских карт',
  'Not issued': 'Не оформлен',
  'Clone hardware model': 'Скопировать модель оборудования',
  'Clone price plan': 'Скопировать тарифный план',
  'Clone subscription': 'Скопировать абонемент',
  Active: 'Активен',
  'active-orders': 'Активные',
  Disabled: 'Не активен',
  'Ride allow': 'Ездить разрешено',
  'Ride restrict': 'Ездить запрещено',
  'Finish allow': 'Финиш разрешен',
  'Finish restrict': 'Финиш запрещен',
  'Riding allowed': 'Ездить разрешено',
  'Riding prohibited': 'Ездить запрещено',
  'Right to edit': 'Право на редактирование',
  'Parking allowed': 'Парковка разрешена',
  'Parking prohibited': 'Парковка запрещена',
  'Geofences and geopoints': 'Геозоны и геоточки',
  'Age limit': 'Возрастное ограничение',
  'Has mechanical lock code': 'Код механического замка указан',
  'Hasn\'t mechanical lock code': 'Код механического замка не указан',
  'Mechanical lock status': 'Статус механического замка',
  'Hasn\'t mechanical lock': 'Не имеет механического замка',
  'Steering wheel': 'Рулевое колесо',
  Accelerator: 'Газ',
  Brake: 'Тормоз',
  Wheels: 'Колеса',
  'When copying a tariff, you must specify which type of tariff the new one will belong to. In case of creating an analogue of the basic tariff to provide it within the framework of the subscription, select "Subscription". Otherwise - select "Basic"':
    'При копировании тарифа необходимо указать к какому типу тарифа будет относиться новый. В случае создания аналога базового тарифа для предоставления его в рамках абонемента, выберите "Абонемент". В противном случае - выберите "Базовый"',
  'When you select the Activation for a group of clients destination of the subscription, in the appeared field you\'ll need to select a group of clients for whom the subscription will be automatically activated upon turning on the subscription by the user. When you select the Purchase by client destination of the subscription, it will be available for purchase to all clients in the specified region.':
    'При выборе предназначения абонемета Активация для группы клиентов, появится поле выбора группы клиентов, для которых абонемент будет автоматически активирован по факту включения абонемента пользователем. При выборе предназначения абонемента Покупка клиентом, абонемент будет доступен для покупки всем клиентам в указанном регионе.',
  'When the rental office is closed, the services provided will not be available for requests in the mobile app for couriers.':
    'При закрытии офиса проката оказываемые услуги будут недоступны для заявок в мобильном приложении для курьеров.',
  'When creating an IoT module, its registration number is generated automatically based on the prefix of the hardware manufacturer specified in the hardware model and the numerical part specified in the corresponding field of the IoT module creation form.': 'При создании IoT-модуля, его регистрационный номер генерируется автоматически по префиксу производителя оборудования, указанного в модели оборудования, и числовой части, указанной в соответствующем поле формы создания IoT-модуля.',
  'When choosing a fixed amount, the client will receive the specified amount upon completion of the trip, regardless of the order cost. With cashback, the customer will receive a specified percentage of the order cost. Important: If the fare already specifies a cashback percentage, the bonuses will not be combined. The system will automatically select the percentage in favor of the client.balance upon completion of the trip. Important: the bonus will only be credited to the client\'s balance after full payment.': 'При выборе фиксированной суммы по завершению поездки клиенту зачислится указанная сумма вне зависимости от стоимости заказа. В случае с кешбэком клиенту зачислится указанный процент от стоимости заказа. Важно: если в тарифе уже указан процент кешбэка, бонусы не суммируются. Значение процента будет выбрано системой автоматически в пользу клиента.',
  'What are we creating?': 'Что создаем?',
  Footboard: 'Подножка',
  Rack: 'Рама',
  Battery: 'Батарея',
  'Basic data': 'Основные данные',
  'Basic rates': 'Базовые тарифы',
  Basic: 'Базовые',
  'Basic price plans': 'Базовые тарифы',
  Other: 'Другое',
  'Operating mode': 'Режим работы',
  'Operation details': 'Детали операции',
  'Operation history': 'История операции',
  'Operating system and version': 'Операционная система и её версия',
  'Broke parts': 'Сломанные части',
  'Public ID': 'Публичный ID',
  'Charge start/finish': 'Заряд старт/финиш',
  Booked: 'Забронирован',
  Pause: 'Пауза',
  km: 'км',
  odometer: 'одометр',
  'by coordinates': 'по координатам',
  'by odometer': 'по одометру',
  'km ago': 'км назад',
  'km/h': 'км/ч',
  'Total cost': 'Общая стоимость',
  Fine: 'Штраф',
  Fines: 'Штрафы',
  'Issue a fine': 'Выписать штраф',
  'Order history': 'История заказов',
  'Order photos': 'Фотографии заказа',
  Copy: 'Копировать',
  Copying: 'Копирование',
  Combat: 'Боевой',
  day: 'день',
  minute: 'минута',
  hour: 'час',
  hours: 'часов',
  hour_: 'часа',
  'Holding error': 'Ошибка холдирования',
  Pay: 'Оплатить',
  'Pay debt': 'Оплатить задолженность',
  'Pay using CloudPayments': 'Оплатить через Cloud',
  'Not paid': 'Не оплачен',
  Paid: 'Оплачен',
  'Paid up': 'Оплачено',
  'Number Prefix': 'Префикс Номера',
  'Vendor prefix': 'Префикс производителя оборудования',
  'Account ID': 'Учетная запись',
  Success: 'Успешно',
  'Order successfully paid': 'Заказ успешно оплачен',
  Enabled: 'Активен',
  'Entity address': 'Юр. адрес',
  'Entity phone': 'Юр. телефон',
  'Entity settlement account': 'Расчётный счёт',
  'Type of entity': 'Тип организации',
  Test: 'Тестовый',
  Testers: 'Тестировщики',
  'Test GPRS/Test connection': 'Тест GPRS/Тест подключения',
  'Connected to server': 'Подключен к серверу',
  'Enable unit grouping': 'Включить группировку объектов',
  'Disable unit grouping': 'Выключить группировку объектов',
  Low: 'Низкий',
  Medium: 'Средний',
  High: 'Высокий',
  'Without broken parts': 'Без сломанных частей',
  'Please wait': 'Пожалуйста, подождите',
  'No messages found': 'Сообщений не найдено',
  MIR: 'МИР',
  'Unit registration number': 'Регистрационный номер объекта',
  Headline: 'Заголовок',
  'Units visibility': 'Видимость объектов',
  'Head: no information': 'Голова: нет информации',
  'Head: is on': 'Голова: включена',
  'Head: is off': 'Голова: выключена',
  'Heat map': 'Тепловая карта',
  'Brake: no information': 'Тормоза: нет информации',
  'Brake: OFF': 'Тормоза: выключены',
  'Brake: ON': 'Тормоза: включены',
  'Speed mode: drive': 'Скоростной режим: drive',
  'Speed mode: eco': 'Скоростной режим: eco',
  'Speed mode: speed': 'Скоростной режим: speed',
  'Speed mode: no information': 'Скоростной режим: нет информации',
  'Specify the priority': 'Укажите приоритет',
  'Specify the reason': 'Укажите причину',
  'Specify purpose': 'Укажите назначение',
  'Specify the region boundaries': 'Укажите границы региона',
  'Specify the geopoint location': 'Укажите местоположение геоточки',
  'Specify the geofence boundaries': 'Укажите границы геозоны',
  'Specify validity period': 'Укажите период действия',
  'Specifies the maximum battery charge of the object, at which the tariff can be displayed in the mobile application for the object.':
    'Указывается максимальный заряд АКБ объекта, при котором можно отображать тариф в мобильном приложении для объекта.',
  'Specify object models for which the tariff will be available.':
    'Укажите модели объектов, для которых будет доступен тариф.',
  'Specifies the user-owner of the objects for which the tariff will be available':
    'Указывается пользователь-владелец объектов, для которых будет доступен тариф',
  'Specify the cost': 'Укажите стоимость',
  'Specify an increasing cycle time': 'Укажите суммарную длительность аренды',
  'Specifies the total duration of the lease in minutes. It is from this value that the travel time will be deducted.':
    'Указывается суммарная длительность аренды в минутах. Именно от этого значения будет списываться время поездок.',
  'Specify the days of the week on which this tariff will be available. You can select all days of the week, weekdays weekends, or a specific day of the week.':
    'Указываются дни недели, в которые будут доступен данный тариф. Можно выбрать все дни недели, рабочие дни выходные дни или же конкретный день недели.',
  'Specify the project in which the object will work':
    'Укажите проект, в котором будет работать объект',
  'Specify the service delivery region for the object. As long as the object\'s service delivery region does not match the object\'s current location, the region name will be outlined in red.':
    'Укажите регион оказания услуг для данного объекта. Пока регион оказания услуг объекта не совпадает с текущим местоположением объекта, название региона будет иметь красное очертание.',
  'Specify the object model. The object model is displayed in the client interface in the object card. Depending on the selected model, the functionality may differ.':
    'Укажите модель объекта. Модель объекта отображается в интерфейсе клиента в карточке объекта. В зависимости от выбранной модели функциональные возможности могут отличаться.',
  'Service mode: is on': 'Сервисный режим: включен',
  'Specify the daily time interval during which the tariff will be available for the selected day of the week.':
    'Укажите суточный интервал времени, в который будет доступен тариф по  выбранному дню недели.',
  'Specify mileage': 'Укажите пробег',
  'Specify seconds': 'Укажите секунды',
  'Specify cost': 'Укажите стоимость',
  'Specify the IMEI of the telematics equipment installed in your facility. Equipment communication with the server depends on the correctness of the specified IMEI. It is recommended to check the correctness of the entered data several times.':
    'Укажите IMEI телематического оборудования, установленного в ваш объект. От корректности указанного IMEI зависит связь оборудования с сервером. Рекомендуется несколько раз проверить корректность введенных данных.',
  'Specify the current mileage of the object. This value will be used to calculate the mileage of the object. ':
    'Укажите текущий пробег объекта. От указанного значения будет вестись отсчет пробега объекта. ',
  'Specify the model of telematics equipment installed in your facility. Depending on the selected model of equipment, the correct operation of message reception, sending commands and functional features of the equipment depends on it.':
    'Укажите модель телематического оборудования, установленного в ваш объект. В зависимости от выбранной модели оборудования зависит корректность работы приема сообщений, отправки команд и функциональных особенностей оборудования.',
  'Specify the integrator to whom the facility is leased.': 'Укажите интегратора, которому осуществляется передача объекта в аренду.',
  'Specify the code of the mechanical lock. It is recommended to change the mechanical lock code as often as possible.':
    'Укажите код механического замка. Рекомендуется как можно чаще менять код механического замка.',
  'Specify the billing model of payment for services.': 'Укажите порядок оплаты оказания услуг платформы.',
  'Specify the amount of negative balance, upon reaching which, the user\'s units will be blocked.':
    'Укажите максимальную сумму отрицательного баланса, при достижении которой, объекты пользователя будут заблокированы.',
  'Specify the minimum balance amount at which the partner\'s units will be blocked. A negative value can be specified.':
    'Укажите минимальную сумму баланса, при достижении которой, объекты пользователя будут заблокированы. Можно указать отрицательное значение.',
  'Specify the minimum number of satellites required for coordinates to be considered valid. Filtering is only applied to online messages to prevent outliers and to pin the unit on the map using the latest valid coordinates. The actual coordinates sent by the equipment are saved in the message history.': 'Укажите минимальное значение количества спутников, при котором координаты будут считаться валидными. Фильтрация применяется только на онлайн сообщения для предотвращения выбросов и фиксации объекта на карте по последним валидным координатам. В истории сообщений сохраняются фактические координаты, присланные оборудованием.',
  'Hidden units': 'Скрытые объекты',
  'Payment deadline': 'Крайний срок оплаты',
  'Specify the currency of payment for the platform services.':
    'Укажите валюту, в которой будут вестись расчеты за оказание услуг платформы.',
  'Specify the billing period for which payment will be charged.':
    'Укажите период расчетов, за который будет взыматься оплата.',
  'Specify the number of days in the calculation period.':
    'Укажите количество дней в периоде расчетов.',
  'Specify the calculation method for the billing period. The "Units" method means that user pays only for those units that had the status "Available" at least once during the billing period. The "Interest" method means that user pays only the % of revenue or paid order value depending on the choice. The "Access Fee" method means that user pays only a fixed fee for the billing period. The "Combined" method may consist of units calculation as well as access fee calculation and the other combinations of calculation methods.':
    'Укажите метод, по которому будут вестись расчеты за оказание услуг платформы. В случае выбора метода расчетов по объектам расчет будет осуществляться исходя из указанной цены объекта, переведенного в статус «Доступен». В случае выбора метода расчетов по проценту расчет будет осуществляться исходя из указанного процента либо от выручки, либо от оплаченной стоимости заказов за расчетный период. В случае выбора метода расчета по абонентской плате расчет будет осуществляться исходя из указанной суммы абонентской платы расчетного периода. В случае выбора метода расчета Комбинированный доступна возможность выбрать несколько вариантов для расчета: объекты, процент, абонентская плата.',
  'Specify the value of interest which will be deducted from the source.':
    'Укажите процент, который будет взыматься из источника.',
  'Specify the source of deduction of interest: Revenue or Order Cost. The source "Order Cost" means that the user pay the interest of paid order value.':
    'Укажите источник снятия процента за оказание услуги: "Выручка" или "Стоимость заказов". При выборе источника "Стоимость заказов" процент будет взыматься только от оплаенной стоимости заказов.',
  'Specify the access fee value for the billing period.':
    'Укажите стоимость абонентской платы за установленный расчетный период.',
  'Specify price of the unit.':
    'Укажите цену тарифицируемой единицы, которая будет взыматься с каждого объекта один раз в указанный расчетный период. Оплата взымается только за объект, переведенный в статус "Доступен"',
  'Specify calculated service type of the combined calculation method: Units, Interest or Access Fee.':
    'Укажите тарифицируемую услугу комбинированного метода расчета: Объекты, Процент или Абонентская плата.',
  'Specify the account login in Latin letters without spaces':
    'Укажите логин учетной записи для входа в систему латинскими буквами без пробелов',
  'Specify the user account password for logging in':
    'Укажите пароль учетной записи пользователя для входа в систему',
  'Specify the user\'s email to be able to recover the password':
    'Укажите email пользователя для возможности восстановления пароля',
  'Specify the user who owns the account': 'Укажите пользователя-владельца учетной записи',
  'Specify the position of the contact person who has access to the user account':
    'Укажите должность контактного лица, имеющего доступ к учетной записи пользователя',
  'Specify the Telegram username of the contact person who has access to the user account.':
    'Укажите имя пользователя контактного лица в Telegram, имеющего доступ к учетной записи пользователя.',
  'Specify a link to the group of the corresponding organization in Telegram in the format https://t.me/BF_news1':
    'Укажите ссылку на группу соответствующей организации в Telegram в формате https://t.me/BF_news1',
  'Specify the regions where the user works.': 'Укажите регионы, в которых работает пользователь.',
  'Specify the access rights to the rate functionality the user should have':
    'Укажите какими правами доступа к функционалу тарифов должен обладать пользователь',
  'Specify the access rights to the subscription functionality the user should have':
    'Укажите какими правами доступа к функционалу абонементов должен обладать пользователь',
  'Specify the acquiring, which will be used for transactions with bank cards to pay for the orders and other purchases.':
    'Укажите эквайринг, по которому будут осуществляться операции по банковским картам для оплаты заказов и других покупок.',
  'Specify the payment service through which the purchase of bonus packages, subscriptions and routes will be available.':
    'Укажите сервисы покупки, по которому будет доступна покупка бонусных пакетов, абонементов, маршрутов.',
  'Specify the user ID (identifier) in the SimManager system to obtain information about the balance of SIM cards.':
    'Укажите ID (идентификатор) пользователя в системе SimManager для получения информации о балансе сим-карт.',
  'Specify the acquiring to which funds will be received when replenishing the balance of a user (integrator, administrator) through the admin panel':
    'Укажите эквайринг, на который будут поступать средства при пополнении баланса пользователя (интегратора, администратора) через панель администратора',
  'Specify the reason for closing the alarm': 'Укажите причину закрытия тревоги',
  'Specify the reason for closing all alarms': 'Укажите причину закрытия всех тревог',
  'Specify the reason for the deviation': 'Укажите причину отклонения',
  'Specify the regions in which the news item should be displayed': 'Укажите регионы, в которых должна отображаться новость',
  'Specify the geofence owner. The geofence owner, as well as their child users with editing permissions, will be able to edit and delete the geofence.': 'Укажите владельца геозоны. Владелец геозоны, а также его дочерние пользователи с правами на редактирование, смогут редактировать и удалять геозону.',
  'Specify the ordinal number of the client\'s activity level achievement': 'Укажите порядковый номер достижения уровня активности клиента',
  'Specify the ordinal number': 'Укажите порядковый номер',
  'Specify the language in which the notification should be sent if there is no translation corresponding to the language of the client\'s device.':
    'Укажите на каком языке необходимо отправлять уведомление, в случае отсутствия перевода, соответствующего языку устройства клиента.',
  'Specify the language in which level name should be displayed if there is no translation corresponding to the language of the client\'s device.':
    'Укажите на каком языке необходимо отображать название уровня, в случае отсутствия перевода, соответствующего языку устройства клиента.',
  'Specify the reason for write-off': 'Укажите причину списания',
  'Specify the unit type(-s) to which the component model belongs':
    'Укажите тип(-ы) объекта, которому относится модель комплектующего.',
  'Specify the unit model(-s) to which the component model belongs': 'Укажите модель(-и) объекта, которой относится модель комплектующего.',
  'Specify the time zone of the region you are creating': 'Укажите часовой пояс региона, который вы создаете',
  'Specify the period of time for the schedule to operate for the specified days of the week within a day.': 'Укажите период времени работы расписания для указанных дней недели в пределах суток.',
  'Specify the geopoint owner. The geopoint owner, as well as their child users with editing permissions, will be able to edit and delete the geopoint.': 'Укажите владельца геоточки. Владелец геоточки, а также его дочерние пользователи с правами на редактирование, смогут редактировать и удалять геоточку.',
  'Specify the language in which the information for the client should be displayed if there is no translation matching the client device language.': 'Укажите на каком языке необходимо отображать информацию для клиента, в случае отсутствия перевода, соответствующего языку устройства клиента.',
  'Specify value': 'Введите значение',
  'Service mode: is off': 'Сервисный режим: выключен',
  'Service mode: no information': 'Сервисный режим: нет информации',
  'Lock: is closed': 'Замок: закрыт',
  'Language not selected': 'Язык не выбран',
  'Lock: is opened': 'Замок: открыт',
  Opened: 'Открыт',
  'Lock: no information': 'Замок: нет информации',
  'Flashlight: is on': 'Фонарик: включен',
  'Flashlight: is off': 'Фонарик: выключен',
  'Flashlight: no information': 'Фонарик: нет информации',
  'Height unknown': 'Высота неизвестна',
  Height: 'Высота',
  'Height(mm)': 'Высота(мм)',
  Organization: 'Организация',
  'Organization name': 'Название организации',
  'Taxpayer identification number': 'ИНН/УНП',
  'Enter taxpayer identification number': 'Введите ИНН/УНП',
  'Select an organization': 'Выберите организацию',
  'Select an icon': 'Выберите иконку',
  'Select an available icon from the icon library': 'Выберите доступную иконку из библиотеки иконок.',
  'd.': 'д.',
  'm.': 'м.',
  'h.': 'ч.',
  'h. ago': 'ч. назад',
  's.': 'с.',
  'Last message time': 'Время последнего сообщения',
  ago: 'назад',
  'Last message time unknown': 'Время последнего сообщения неизвестно',
  'Add acceptance certificate': 'Добавить акт приемки',
  'Acceptance certificates': 'Акты приемки',
  Template: 'Шаблон',
  TIN: 'ИНН(УНП)',
  'Title not selected': 'Название не выбрано',
  'You can use the templates above to automatically replace in this text':
    'Вы можете использовать шаблоны выше для автоматической замены в этом тексте',
  'You have new booking': 'У вас есть новое бронирование',
  'You can change the subscription for a group, in which case the current subscription is deactivated, and the new subscription is activated for all clients of the group.':
    'Вы можете изменить абонемент для группы, при этом действующий абонемнет деактивируется, а новый абонемент активируется для всех клиентов группы.',
  'You can assign a previously created schedule if it\'s suitable, or create a new one. The new schedule will be available in your list for future assignments or adjustments.': 'Вы можете назначить ранее созданное вами расписание, если оно подходит, или создать новое. Новое расписание будет доступно в вашем списке для последующих назначений или корректировки.',
  'You can add icons in PNG or SVG formats with a 1:1 aspect ratio. Recommended icon sizes are 24 x 24 pixels for SVG and 64 x 64 pixels for PNG. The maximum file size is 15 KB.': 'Доступна возможность добавить иконку в форматах PNG или SVG в соотношении сторон 1:1. Рекомендуемые размеры иконок: 24 x 24 пикселя для SVG и 64 x 64 пикселя для PNG. Максимальный размер файла — 15 Кб.',
  'You can immediately select geofences from the list to which the schedule will apply. You can also assign a created schedule when creating a geofence.': 'Вы можете сразу выбрать геозоны из списка, на которые будет распространяться расписание. Также вы можете назначить созданное расписание при создании геозоны.',
  'You can immediately select the tariffs from the list to which the schedule will apply. You can also assign the created schedule when creating the tariff.': 'Вы можете сразу выбрать тарифы из списка, на которые будет распространяться расписание. Также вы можете назначить созданное расписание при создании тарифа.',
  Text: 'Текст',
  'Patterns for set and replace': 'Шаблоны для подстановки и замены',
  'Unit model name': 'Название модели объекта',
  'Integrator Organization name': 'Название Организации интегратора',
  'Integrator can edit data on the object, as well as delete the object':
    'Интегратор может редактировать данные по объекту, а также удалить объект',
  'Scooter registration number': 'Регистрационный номер самоката',
  'Client phone number': 'Номер телефона клиента',
  'Client\'s full name': 'ФИО клиента',
  Created: 'Создан',
  'Electric bikes': 'Эл. велосипеды',
  'Electric scooter': 'Эл. самокат',
  'Electric scooters': 'Эл. самокаты',
  'Electric quad bikes': 'Эл. квадроциклы',
  'Electric-bikes': 'Эл. велосипеды',
  'Electric quad bike': 'Эл. квадроцикл',
  'Electric quad bike price': 'Цена эл. квадроцикла',
  'Electric scooter price': 'Цена эл. самоката',
  'Each geofence type has its own logic and corresponding color. Detailed information on each geofence type and its logic is available in the project documentation. To access the documentation, please contact the project support team.': 'Каждый тип геозоны имеет свою логику и соответствующий цвет. Подробная информация о каждом типе геозоны и логике работы доступна в документации проекта. Для получения доступа к документации обратитесь в службу поддержки проекта.',
  Apartment: 'Квартира',
  Station: 'Станция',
  'Station price': 'Цена станции',
  Starts: 'Старты',
  'Is used': 'Используется',
  'Click to change state': 'Нажмите, чтобы изменить состояние',
  'Acceptance certificate state successfully changed': 'Состояние акта приемки успешно изменено',
  'Are sure you want to delete this acceptance certificate': 'Действительно удалить этот акт приемки',
  'Are sure you want to delete this language': 'Действительно удалить этот язык',
  'Successfully deleted': 'Успешно удален',
  'Delete failed': 'Удалить не удалось',
  'Go Back': 'Назад',
  'Go to': 'Перейти',
  'Good signal': 'Хороший сигнал',
  'Google API-key not valid': 'Google API-key недействителен',
  'Google Maps Settings': 'Настройка Google Maps',
  'Download application link': 'Ссылка для скачивания приложения',
  Debt: 'Задолженность',
  Decrease: 'Уменьшение',
  'Debt / Fines': 'Задолженность / Штрафы',
  'Day of the week not selected': 'День недели не выбран',
  'Debt currency': 'Валюта задолженности',
  'Debt repayments': 'Списания',
  'Debt repayments from': 'Списание задолженности от',
  'Search by LBS': 'Найти по LBS',
  Search: 'Поиск',
  'Search for': 'Искать',
  'Search by name': 'Поиск по названию',
  precision: 'Точность',
  'LBS coordinates': 'Координаты по LBS',
  'Cancel debt': 'Отменить задолженность',
  Cancel: 'Отменить',
  'Retry attempt': 'Повторить попытку',
  Cancellation: 'Отмена',
  'Cancel insurance': 'Аннулировать страховку',
  'Are sure you want to cancel insurance': 'Действительно хотите аннулировать страховку',
  'Insurance successfully canceled': 'Страховка успешно аннулирована',
  'An error occurred while trying to cancel insurance': 'При попытке аннулирования страховки возникла ошибка',
  'Error in price plan': 'Ошибка в тарифе',
  'Insurance payment error': 'Ошибка оплаты страховки',
  Min: 'Мин.',
  min: 'мин.',
  Minutes: 'Минуты.',
  Max: 'Макс.',
  'less than 5 minutes': 'менее 5 минут',
  '5 to 15 minutes': 'от 5 до 15 минут',
  '15 to 30 minutes': 'от 15 до 30 минут',
  'more than 30 minutes': 'более 30 минут',
  '80% to 100%': 'от 80% до 100%',
  '50% to 79%': 'от 50% до 79%',
  '20% to 49%': 'от 20% до 49%',
  'Max debt amount': 'Максимальная сумма задолженности',
  'Minimum balance': 'Мимимальный баланс',
  'The maximum length of the identifier is 100 characters. Only lowercase Latin letters (a-z), numbers, hyphens and underscores are allowed':
    'Максимальная длина идентификатора 100 символов. Допускаются только строчные латинские буквы (a-z), цифры, дефисы и подчёркивания',
  'The main screen of the app displays only three recent unread news items. You can pin an important news item to display it on the main screen every time the app is launched, regardless of whether it has been read/hidden by the client or not. We do not recommend pinning more than one news item.':
    'На главном экране приложения отображается не более трех последних непрочитанных новостей. Вы можете закрепить важную новость, чтобы отображать её на главном экране при каждом запуске приложения, вне зависимости от того, была ли она прочитана / скрыта клиентом, или нет. Мы не рекомендуем закреплять более одной новости.',
  'Maximum duration of the trip': 'Макс. длительность поездки',
  'Maximum duration of the trip (-1 - no limits)': 'Макс. длительность поездки (-1 - без ограничений)',
  'Debt canceled successfully': 'Задолженность успешно отменена',
  'Debt successfully paid': 'Задолженность успешно оплачена',
  'Remaining number of uses': 'Оставшееся количество использований',
  'LBS search': 'Поиск по LBS',
  'Not enough data to search for LBS': 'Недостаточно данных для поиска по LBS',
  'Not enough cash': 'Недостаточно денежных средств',
  'Units count': 'Количество объектов',
  'Units active count by period': 'Количество активных объектов за период',
  'Units event log': 'Журнал событий объектов',
  'Amount for period by active units': 'Сумма за период по активным объектам',
  'Fixed amount': 'Фиксированная сумма',
  Messages: 'Сообщения',
  Latitude: 'Широта',
  'Latest photos': 'Последние фото',
  Longitude: 'Долгота',
  Parameters: 'Параметры',
  'Parent account blocked': 'Заблокирован родитель',
  Course: 'Курс',
  'Report by users': 'Отчет по пользователям',
  'Representative\'s name': 'Имя представителя',
  'Data collection time': 'Время сбора данных',
  'Date and time of connection': 'Дата и время подключения',
  From: 'С',
  To: 'По',
  'Number days in minus': 'Количество дней в минус',
  'Number of days': 'Количество дней',
  'Active units amount': 'Сумма за активные объекты',
  'All units amount': 'Сумма за все объекты',
  'Chat in whatsapp': 'Написать в whatsapp',
  'Journal orders': 'Журнал заказов',
  'User id': 'ID пользователя',
  'Time start': 'Время начала',
  'Store ID': 'Идентификатор магазина',
  'Last Order Finish Time': 'Время последнего заказа',
  'Secret Key': 'Секретный ключ',
  'Security mode': 'Охранный режим',
  'Security mode: is on': 'Охранный режим: включен',
  'Security mode: is off': 'Охранный режим: выключен',
  'Security mode: no information': 'Охранный режим: нет информаци',
  'Public Key': 'Публичный ключ',
  'Technical area': 'Техническая зона',
  'Technics territories': 'Территории техника',
  'Technics territory': 'Территория техника',
  Technicians: 'Техники',
  Technician: 'Техник',
  'Balance in coins': 'Баланс в монетах',
  'Balance in currency': 'Баланс в валюте',
  'On Charge': 'На зарядке',
  Alarm: 'Тревога',
  'On Charge At Stock': 'На зарядке на складе',
  'Not Available': 'Не доступен',
  Stolen: 'Украден',
  'Under Repair': 'В ремонте',
  Donor: 'Донор',
  'Not set': 'Не задан',
  'SIM cards balance': 'Баланс SIM-карт',
  'User balance': 'Баланс пользователя',
  'Balance report': 'История баланса',
  'Balance report 2023': 'История баланса 2023',
  'Paid message log': 'Журнал платных сообщений',
  'Close all': 'Закрыть все',
  'Close all alarms': 'Закрыть все тревоги',
  'Description details': 'Подробности описания',
  Routes: 'Маршруты',
  Purchases: 'Покупки',
  'Purchase by client': 'Покупка клиентом',
  'Purchase log': 'Журнал покупок',
  'End user': 'Клиент',
  'End of billing period': 'Окончание расчётного периода',
  Ending: 'Окончание',
  'Only a user with the administrator role can be the project owner': 'Владельцем проекта может быть только пользователь с ролью администратор',
  'Only administrator or integrator can be the owner of the news item.':
    'Владельцем новости может быть либо администратор, либо интегратор',
  'Free-form project name': 'Название проекта в произвольной форме',
  'The unique identifier is used to bind the mobile app to the project. It\'s the name of the project, written in small Latin letters without spaces or special characters. IMPORTANT!!! Once the project is created, the unique identifier cannot be changed!':
    'Уникальный идентификатор предназначен для связи проекта с мобильным приложением. Представляет собой название проекта, написанное маленькими латинскими буквами без пробелов и спецсимволов. ВАЖНО!!! После создания проекта уникальный идентификатор не может быть изменен!',
  'Simple registration contains a basic information about the client and doesn\'t require document verification. Extended registration contains supporting documents that are sent for moderation to the project administrator and/or project manager with moderator functionality.'
    : 'Простая регистрация содержит минимум информации о клиенте и не требует проверки документов. Расширенная регистрация содержит подтверждающие документы, которые отправляются на модерацию администратору проекта и/или менеджеру проекта с функционалом модератора.',
  'The extended registration type determines the set of supporting documents. Detailed information is available in the platform documentation.':
    'Расширенный тип регистрации определяет набор подтверждающих документов. Подробная информация доступна в документации платформы.',
  'One-time password is valid for only one authentication session and is provided to the client by one of the available sources. A reusable password is created when registering a client account and its use for authentication is unlimited.'
    : 'Одноразовый пароль действителен только для одного сеанса аутентификации и предоставляется клиенту одним из доступных источников. Многоразовый пароль создается при регистрации учетной записи клиента, и его использование для аутентификации неограничено.',
  'Specify the sources of provision of one-time password to the client.':
    'Укажите источники предоставления одноразового пароля клиенту.',
  'Provide the phone number of the Telegram Gateway account owner.': 'Укажите номер телефона владельца учетной записи Telegram Gateway.',
  'Provide a link to the document posted on the project\'s official website.': 'Укажите ссылку на документ, размещенный на официальном сайте проекта',
  'API token can be obtained in the Telegram Gateway settings on the API page.': 'API token можно получить в настройках Telegram Gateway на странице API',
  'You can optionally specify the sender username, designating a verified channel you own as the one from which the code will be sent to the user.':
    'Вы можете опционально указать имя отправителя, указав верифицированный канал, которым вы владеете, как тот, с которого код будет отправлен пользователю.',
  'Specify the outgoing mail server address': 'Укажите адрес сервера исходящей почты',
  'Specify the outgoing mail server port': 'Укажите порт сервера исходящей почты',
  'Specify the encryption type': 'Укажите тип шифрования',
  'Specify the sender email': 'Укажите Email отправителя',
  'Enter username': 'Укажите имя пользователя',
  'Specify the email password': 'Укажите пароль почты отправителя',
  'Specify the minimum age of the client': 'Укажите минимальный возраст клиента',
  'Specify the document signature text, including a link to the document in the form of the document name, using the automatic data substitution template - {{documentLinkName}}': 'Укажите текст подписания документа, включающий ссылку на документ в виде названия документа, используя шаблон автоматической подстановки данных — {{documentLinkName}}',
  'A short smart link of the service that redirects the user to the desired app store depending on the device. The link is automatically added to the QR code of the unit before the registration number. Thus, when scanning the QR code of the unit with the camera in the mobile app, the unit is booked, and when scanning with the camera of a mobile phone, the transition to the app page for downloading is performed.'
    : 'Короткая интеллектуальная ссылка сервиса, который перенаправляет пользователя в нужный магазин приложений в зависимости от устройства. Ссылка автоматически добавляется в QR -код объекта перед регистрационным номером. Таким образом, при сканировании QR кода объекта камерой в мобильном приложении, осуществляется бронирование объекта, а при сканировании камерой мобильного телефона, осуществляется переход в магазин приложений на страницу приложения для скачивания.',
  'Used to navigate to the mobile app when confirming the client\'s Email on an iOS device. Provided by the developer':
    'Используется для перехода в мобильное приложение при подтверждении Email клиента на iOS устройстве. Предоставляется разработчиком',
  'Used to navigate to the mobile app when confirming the client\'s Email on an Android device. Provided by the developer':
    'Используется для перехода в мобильное приложение при подтверждении Email клиента на Android устройстве. Предоставляется разработчиком',
  'To credit cashback to the balance of clients in all completed and successfully paid orders of the project, it is necessary to specify the value in percentage.'
    : 'Для зачисления кешбэка на баланс клиентов во всех завершенных и успешно оплаченных заказах проекта необходимо указать значение в процентах.',
  'Manage visibility of units in the client mobile app. Should be enabled by default. If you need to hide temporarily all units of the project from clients without changing status of the units, you should uncheck the box.'
    : 'Управление видимостью объектов в клиентском мобильном приложении. По умолчанию должно быть включено.' +
    ' В случае необходимости временного скрытия всех объектов проекта от клиентов без изменения статуса объектов, необходимо снять чек-бокс.',
  'Tourist route price plan': 'План туристического маршрута',
  'Duration days': 'Продолжительность дней',
  'Time of purchase request': 'Время запроса на покупку',
  'Payment status': 'Статус платежа',
  'Time of purchase completion': 'Время совершённой покупки',
  'Is activated': 'Активна ли покупка',
  'Tourist route purchase identifier': 'Идентификатор покупки туристического маршрута',
  'Vat rate': 'Ставка НДС',
  'Taxation system': 'Система налогооблажения',
  'Clients with debt': 'Клиенты с задолженностью',
  Gallery: 'Галерея',
  'Show all': 'Показать все',
  Next: 'Следующий',
  Prev: 'Предыдущий',
  'Last day': 'Последний день',
  'Chat to WhatsApp': 'Написать в WhatsApp',
  'Order id': 'ID заказа: ',
  'Client login': 'Логин клиента: ',
  'Client activity levels': 'Уровни активности клиента',
  Current: 'Текущий',
  'Currency code': 'Валюта: ',
  'Customize notifications by unit': 'Настройка уведомлений по объектам',
  'Customize notifications by client': 'Настройка уведомлений по клиентам',
  'Customization settings': 'Настройка кастомизации',
  'Order price': 'Общая цена заказа: ',
  'Order start time': 'Время начала заказа',
  'Order finish time': 'Время окончания заказа',
  'Order completion': 'Завершение заказа',
  'Ordering statistics': 'Статистика по заказам',
  'Price plan name': 'Название тарифа: ',
  'Last order': 'Последний заказ',
  Hour: 'Час',
  'next day': 'след. день',
  'prev. day': 'пред. день',
  'next week': 'след. неделя',
  'prev. week': 'пред. неделя',
  'next month': 'след. месяц',
  'prev. month': 'пред. месяц',
  week: 'неделя',
  month: 'месяц',
  'Reset filters': 'Сбросить фильтры',
  'Pay penalty': 'Оплатить штраф',
  'Cancel penalty': 'Отменить штраф',
  'Penalty successfully paid': 'Штраф успешно оплачен',
  'Penalty canceled successfully': 'Штраф успешно отменен',
  'Confirm cancellation': 'Подтвердить отмену',
  'Consider the amount': 'Учитывать сумму',
  'Consider the duration': 'Учитывать длительность',
  'Consent text': 'Текст согласия',
  Confirm: 'Подтвердить',
  'Reason for canceling fine': 'Причина отмены штрафа',
  'Reason for canceling': 'Причина отмены',
  'Reason for write-off of property': 'Причина списания имущества',
  'Reason for subscription termination': 'Причина прекращения подписки',
  'Debt for fine': 'Задолженность по штрафу',
  'Debt for trip': 'Задолженность по поездке',
  'Your reason for closing all notifications': 'Причина закрытия уведомлений',
  'Client location at end of lease': 'Местоположение клиента по окончанию аренды',
  'Unit location at end of lease': 'Местоположение объекта по окончанию аренды',
  'Trip info': 'Информация о поездке',
  'Limit error, use filters': 'Слишком большой результат, используйте фильтры',
  'List of clients': 'Список клиентов',
  'List of couriers': 'Список курьеров',
  Limit: 'Ограничение',
  'Trip start': 'Начало поездки',
  'Trip continue': 'Продолжение поездки',
  'Trip finish': 'Завершение поездки',
  'Distance from Unit to Client, m': 'Расстояние от объекта до клиента, м',
  m: 'м',
  'hh:mm': 'чч:мм',
  'hh:mm:ss - hh:mm:ss': 'чч:мм:сс - чч:мм:сс',
  'Order start place': 'Место начала заказа',
  'Order finish place': 'Место завершения заказа',
  'Orders price': 'Сумма по заказам',
  'Bank card type': 'Тип банковской карты',
  'Bank cards': 'Банковские карты',
  'Bank card last four digits': 'Последние четыре цифры банковской карты',
  Banking: 'Банковские',
  'Bank card': 'Банковская карта',
  'Notification link': 'Ссылка на уведомление',
  'Send notifications': 'Рассылка уведомлений',
  'Preview image': 'Заглавная картинка',
  'Has furniture': 'Есть мебель',
  'Has fridge': 'Есть холодильник',
  'With kids': 'Можно с детьми',
  Floor: 'Этаж',
  'Window view': 'Вид из окна',
  'Rooms amount': 'Колличество комнат',
  'Quality repair': 'Ремонт',
  'Question type': 'Тип вопроса',
  Question: 'Вопрос',
  'Select question type': 'Выберите тип вопроса',
  'Value should be like 12+13+14': 'Значение должно быть 12+13+14',
  'The value must be at least 6 characters.': 'Значение должно быть не менее 6 символов.',
  'Invalid value': 'Неверное значение',
  'Invalid format. Allowed: ': 'Недопустимый формат. Разрешены: {{params}}',
  Balcony: 'Балкон',
  Bathroom: 'Санузел',
  'Square meter rooms': 'Площадь комнат',
  'Square meter kitchen': 'Площадь кухни',
  'Square meter living': 'Жилая площадь',
  'Square meter full': 'Общая площадь',
  'Closest metro': 'Ближайшее метро',
  'Minutes to metro': 'Минут до метро',
  'Floors total in building': 'Всего этажей в доме',
  'Maximum amount of people': 'Максимальное колличество людей',
  'Next maintenance mileage': 'Следующее ТО',
  'With conditioner': 'Есть кондиционер',
  'With dishwasher': 'Есть посудомоечная машина',
  'With washer': 'Есть стиральная машина',
  'With tv': 'Есть телевизор',
  'With pets': 'Можно с домашними животными',
  'Near reservoir': 'Рядом водоём',
  'Near park': 'Рядом парк',
  'Year of construction': 'Год постройки',
  'Year of card expiry': 'Год окончания срока действия карты',
  'Yandex Maps Settings': 'Настройка Yandex Maps',
  'Ceiling height': 'Высота потолков',
  'Certificate of absence (presence) of a criminal record': 'Справка об отсутствии (наличии) судимости',
  Parking: 'Парковка',
  'House type': 'Тип дома',
  'Accommodation type': 'Тип жилья',
  'Price for day': 'Цена за сутки',
  Bookings: 'Бронирования',
  'Booking info': 'Информация о бронировании',
  'Invalid year of construction': 'Невалидный год постройки',
  'Name can only contain letters, numbers, dashes and underscores':
    'Название может содержать только буквы, цифры, дефисы, знаки подчеркивания',
  'Login can only contain letters, numbers, dashes and underscores':
    'Логин может содержать только буквы, цифры, дефисы, знаки подчеркивания',
  'Login can\'t contain a whitespace': 'Логин не может содержать пробел',
  'Name can\'t start with dash or underscore characters': 'Название не может начинаться с дефиса или подчеркивания',
  'Internal name will be used for administrative purposes only and will not be available to the client.':
    'Внутреннее название используется только в административных целях и не будет доступно клиенту.',
  'Unit type name may only contain lowercase latin letters, hyphens and underscores':
    'Название типа объекта может содержать только латинские буквы в нижнем регистре, дефисы и символы подчеркивания',
  'Unit types': 'Типы объектов',
  'Apartment number': 'Номер квартиры',
  apartment: 'квартира {{val}}',
  'Email host': 'Хост электронной почты',
  'Email username': 'Имя пользователя почты',
  'Email password': 'Пароль почты',
  'Email port': 'Порт почты',
  'Email encryption': 'Тип шифрования',
  'Email from': 'Электронная почта для отправки',
  Date: 'Дата',
  'Date from': 'Дата начала',
  'Date to': 'Дата окончания',
  'Confirm version': 'Подтвердить изменение',
  'Reject version': 'Отклонить изменение',
  Reject: 'Отклонить',
  'Delivery time': 'Время доставки',
  'Delivery address': 'Адрес доставки',
  'Return address': 'Адрес возврата',
  'Delivery point': 'Точка доставки',
  'Return point': 'Точка возврата',
  Returned: 'Вернувшиеся',
  'Active booking': 'Активное бронирование',
  'Activation log': 'Журнал активации',
  'Another region': 'Другой регион',
  'Value time is not correct': 'Время введено не правильно',
  Updated: 'Обновлено',
  'Update type': 'Тип изменения',
  Update: 'Изменить',
  'Car delivered': 'Машина доставлена',
  'Car price': 'Цена автомобиля',
  'Card expiry month': 'Месяц окончания срока действия карты',
  'Close booking': 'Закрыть бронирование',
  'Request for update': 'Запрос на обновление',
  'Request to fill out the registration form': 'Запросить заполнение формы регистрации',
  'Fill out the registration form yourself': 'Заполнить форму регистрации самостоятельно',
  Recalculate: 'Пересчитать',
  'Order created': 'Заказ создан',
  'Order cost': 'Стоимость заказа',
  'Update confirmed': 'Обновление подтверждено',
  'Update rejected': 'Обновление отклонено',
  'Upload a file in .txt format with a list of customers\' phone numbers in a column, without spaces or other punctuation marks.':
    'Загрузите файл в формате txt со списком номеров клиентов, прописанных в столбик, без пробелов и других знаков препинания.',
  'Upload the document in HTML format, having previously specified the necessary data substitution templates in its content.': 'Загрузите документ в формате html, предварительно указав в его содержании необходимые шаблоны подстановки данных.',
  'Upload a photo of the document': 'Загрузите фотографию документа',
  'Upload the document (HTML)': 'Загрузите документ (HTML)',
  'Booking closed': 'Бронирование закрыто',
  'Booking confirmation': 'Подтверждение бронирования',
  'Bonus package purchases': 'Покупки бонусных пакетов',
  'Bonus on order completion': 'Бонус по завершении заказа',
  'End user type': 'Тип клиента',
  'Cot amount': 'Количетсво детских кроваток',
  'Entrance number': 'Номер подъезда',
  entrance_number: 'подъезд {{val}}',
  'Enter ID': 'Введите ID',
  'Enter API-key': 'Введите API-key',
  'Enter email': 'Введите email',
  'Enter code': 'Введите код',
  'Enter contact': 'Введите контакт',
  'Enter consent text': 'Введите текст согласия',
  'Enter the amount': 'Введите количество',
  'Enter value': 'Введите стоимость',
  'Enter the name': 'Введите имя',
  'Enter phone number': 'Введите номер телефона',
  'Enter last name': 'Введите фамилию',
  'Enter middle name': 'Введите отчество',
  'Enter the interest value': 'Введите значение процента',
  'Enter the amount value': 'Введите значение суммы',
  'Enter the amount in hours': 'Введите значение суммы  в часах',
  'Enter the document text': 'Введите текст документа',
  'Enter the signing text': 'Введите текст подписания',
  'Enter the cashback percentage': 'Укажите процент кешбэка.',
  'Enter the amount in the country\'s currency': 'Укажите сумму в валюте страны.',
  'Enter number of days': 'Введите количество дней',
  'Enter number': 'Введите  номер',
  'Enter number prefix': 'Введите префикс номера',
  'Enter subscription name': 'Введите название абонемента',
  'Enter a name': 'Введите название',
  'Enter a name for the new schedule.': 'Введите название нового расписания.',
  'Enter a name for the icon.': 'Укажите название иконки.',
  'Enter a unique identifier': 'Введите уникальный идентификатор',
  'Enter an address': 'Введите адрес',
  'Enter short description text': 'Введите текст краткого описания',
  'Enter short description text 1': 'Введите текст краткого описания 1',
  'Enter short description text 2': 'Введите текст краткого описания 2',
  'Enter text for detailed description': 'Введите текст подробного описания',
  'Enter text to search': 'Введите текст для поиска',
  'Enter name of the rate': 'Введите название тарифа',
  'Enter name': 'Введите название',
  'Enter service name 1': 'Введите название услуги 1',
  'Enter service name 2': 'Введите название услуги 2',
  'Enter service name 3': 'Введите название услуги 3',
  'Enter service name 4': 'Введите название услуги 4',
  'Enter price': 'Введите цену',
  'Enter price for service 1': 'Введите цену на услугу 1',
  'Enter price for service 2': 'Введите цену на услугу 2',
  'Enter price for service 3': 'Введите цену на услугу 3',
  'Enter price for service 4': 'Введите цену на услугу 4',
  'Enter cost': 'Введите стоимость',
  'Enter description text': 'Введите текст описания',
  'Enter description': 'Введите описание',
  'Enter driver\'s license number': 'Введите номер водительского удостоверения',
  'Enter serial number': 'Введите порядковый номер',
  'Enter series and document number': 'Введите серию и номер документа',
  'Enter charge value': 'Введите значение заряда',
  'Enter the serial number of the object': 'Укажите серийный номер объекта',
  'Enter registration number': 'Введите регистрационный номер',
  'Enter IMEI': 'Введите IMEI',
  'Enter reg. object number': 'Введите рег. номер объекта',
  'Enter net cost': 'Введите себестоимость',
  'Enter a free-form description of the color, for example, "Beige", "Metallic Green", etc.':
    'Введите в произвольной форме описание цвета, например, «Бежевый», «Зеленый металлик» и др.',
  'Enter the number of the SIM card installed in the telematics equipment':
    'Укажите номер SIM-карты, установленной в телематическом оборудовании',
  'Enter comment text': 'Введите текст комментария',
  'Enter text': 'Введите текст',
  'Enter name of the group': 'Введите имя группы',
  'Enter a comment': 'Введите комментарий',
  'Enter amount': 'Введите сумму',
  'Enter percentage': 'Введите процент',
  'Enter command text': 'Введите текст команды',
  'Enter notification text': 'Введите текст уведомления',
  'Enter the number of days to pay the invoice. Invoice date for the billing period is the start date of a new billing period. Account will be blocked in case of non-payment of the debt within the specified period.':
    'Укажите количество дней на оплату с момента выставления счета. Моментом выставления счета считается начало нового расчетного периода. В случае не поступления денежных средств по выставленному счету в течение установленного периода, учетная запись будет заблокирована.',
  'Enter text of the client\'s agreement to the terms of the document. For example: "I have read the terms of the privacy policy and, by checking this box, I agree to its terms."': 'Введите сопровождающий текст согласия клиентом условий документа. Например: «Я ознакомился с условиями политики конфиденциальности и, ставя галочку в данном поле, соглашаюсь с его условиями».',
  'Enter mileage': 'Введите пробег',
  'Enter account login': 'Введите логин учетной записи',
  'Enter login': 'Введите логин',
  'Enter your name': 'Введите имя',
  'Enter your phone number': 'Введите номер телефона',
  'Enter password': 'Введите пароль',
  'Enter a password': 'Ввести пароль',
  'Enter passport number': 'Введите номер паспорта',
  'Enter position': 'Введите должность',
  'Enter port': 'Введите порт',
  'Enter API token': 'Введите API token',
  'Enter the Full Name of the contact person who has access to the user account':
    'Укажите Фамилию Имя Отчество контактного лица, имеющего доступ к учетной записи пользователя',
  'Enter the phone number of the contact person who has access to the user account in the format +375291111111':
    'Укажите номер телефона контактного лица, имеющего доступ к учетной записи пользователя',
  'Enter the number n the format +375291111111': 'Введите номер в формате +375291111111',
  'Enter the user name in the format @ivanovivanivanovich': 'Введите имя пользователя в формате @ivanovivanivanovich',
  'Enter the link in the format https://t.me/BF_news1': 'Введите ссылку в формате https://t.me/BF_news1',
  'Enter the address of registration': 'Укажите адрес регистрации',
  'Enter the name of the client\'s activity level. This name will be used for administrative purposes only and will not be available to the client. The client\'s activity level name is set when adding transfers':
  'Укажите внутреннее название уровня активности клиента. Это название будет использоваться только в административных целях и не будет доступно клиенту. Название уровня активности для клиента устанавливается при добавлении переводов',
  'Enter the name of the parameter by which the battery charge level value will be calculated': 'Введите название параметра, по которому будет осуществляться вычисление значения уровня заряда АКБ',
  'Enter the address of your actual residence': 'Укажите адрес фактического проживания',
  'Enrollment form': 'Форма зачисления',
  'Enter Push notification text': 'Введите текст Push-уведомления',
  'Enter verification code': 'Введите проверочный код',
  'Enter promo code': 'Введите промокод',
  'Enter a short description': 'Введите краткое описание',
  'Enter a detailed description': 'Введите подробное описание',
  'Enter the title of the question': 'Введите заголовок вопроса',
  'Enter a heading': 'Введите заголовок',
  'Enter age': 'Введите возраст',
  'Enter the cashback percentage value': 'Введите значение процента кешбэка',
  'Enter the key': 'Введите ключ',
  'Enter the minimum duration': 'Введите минимальную длительность',
  'Enter sort priority': 'Введите приоритет сортировки',
  'Enter parameter name': 'Введите название параметра',
  'Enter parameter value': 'Введите значение параметра',
  'Enter the translation of the client activity level name':
    'Укажите название уровня активности клиента на выбранном языке перевода.',
  'Enter the internal name of the branch in any format. The internal name is used for administrative purposes only and is not used in the mobile app for clients.':
  'Укажите внутреннее название филиала в произвольной форме. Внутреннее название используется только в административных целях и не отображается в мобильном приложении для клиентов.',
  'Enter the internal name of the Legal Entity in any format. The internal name is used for administrative purposes only and is not used in the mobile app for clients.':
  'Укажите внутреннее название юридического лица в произвольной форме. Внутреннее название используется только в административных целях и не отображается в мобильном приложении для клиентов.',
  'Enter the value of the parameter, upon reaching which the charge level will be 0%': 'Введите значение параметра, при достижении которого уровень заряда будет принимать значение 0%.',
  'Enter the value of the parameter, upon reaching which the charge level will be 100%': 'Введите значение параметра, при достижении которого уровень заряда будет принимать значение 100%.',
  'Enter the document name that will be available to the client in the mobile app.': 'Введите название документа, которое будет доступно клиенту в мобильном приложении.',
  'Enter a name for the geopoint. We recommend adding, for example, an address to the name, so you can quickly find the geopoint in the list if needed.': 'Укажите название геоточки. Рекомендуем в название добавлять, например, адрес, чтобы при необходимости можно было быстро найти геоточку в списке.',
  'Passport number': 'Номер паспорта',
  'Passport term': 'Срок действия паспорта',
  'Passport series and number': 'Серия и номер паспорта',
  'Series and number': 'Серия и номер',
  'Passport photo': 'Фотография паспорта',
  'Passport photo (New)': 'Фотография паспорта (Новое)',
  'Passport selfies': 'Селфи с паспортом',
  'Passport selfies (New)': 'Селфи с паспортом (Новое)',
  'Driver license number': 'Номер прав',
  'Driver\'s license number': 'Номер водительского удостоверения',
  'Driver\'s license category': 'Категория водительского удостоверения',
  'Driver license term': 'Срок действия прав',
  Passport: 'Паспорт',
  'Selfie with passport': 'Селфи с паспортом',
  'Driver\'s license': 'Водительское удостоверение',
  'Driver license front': 'Водительское удостоверение, передняя сторона',
  'Driver license back': 'Водительское удостоверение, задняя сторона',
  'Validity period of driver\'s license': 'Срок действия водительского удостоверения',
  'Driver\'s licence. Front side': 'Водительское удостоверение. Лицевая сторона',
  'Driver\'s licence. Front side (New)': 'Водительское удостоверение. Лицевая сторона (Новое)',
  'Driver\'s licence. Reverse side': 'Водительское удостоверение. Обратная сторона',
  'Driver\'s licence. Reverse side (New)': 'Водительское удостоверение. Обратная сторона (Новое)',
  'Driver\'s license categories': 'Категории водительского удостоверения',
  Selfie: 'Селфи',
  'E-mail': 'E-mail',
  'Term of use': 'Пользовательское соглашение',
  'Privacy policy': 'Согласие на обработку данных',
  'End user verified': 'Клиент подтверждён',
  'End user rejected': 'Данные пользователя отклонены',
  'Can\'t verify end user, everything has to be confirmed': 'Невозможно подтвердить клиента, все шаги регистрации должны быть потверждены',
  'Registration data': 'Регистрация клиента',
  'Registration history': 'История прохождения регистрации',
  'Registration number must correspond to the specified number in the name of the object (numerical value). Based on the specified registration number, the system generates a QR code required for ordering an object by a client. If for some reason the QR code is not readable, the customer enters the registration number manually to start the rental.':
  'Регистрационный номер должен соответствовать указанному номеру в названии объекта (цифровое значение). На основании указанного регистрационного номера системой генерируется QR-код, необходимый для заказа объекта клиентом. Если по какой-то причине QR-код не считывается, для начала аренды клиент вводит регистрационный номер вручную.',
  'Nothing to reject': 'Ничего не выбрано',
  'Nothing found': 'Ничего не найдено',
  'Return to customer': 'Отклонить клиента',
  'Verify account': 'Подтвердить аккаунт',
  'Verified sender name': 'Верифицированное имя отправителя',
  'Maximum people allowed': 'Максимальное количество людей разрешено',
  'Confirm apartment': 'Подтвердить квартиру',
  'Arrive time': 'Время прибытия',
  'Departure time': 'Время выезда',
  'Depending on the selected type of subscription, different conditions for its provision are available. Starts - type of subscription to provide access to tariffs with zero cost of starts for a set period of validity of the subscription. Minutes - type of subscription to provide free rental minutes for a set period of validity of the subscription. Trips - a type of subscription for providing free trips for a set period of validity.':
    'В зависимости от выбранного типа абонемента доступны различные условия его предоставления. Старты - тип абонемента для предоставления доступа к тарифам с нулевой стоимостью стартов на установленный период действия абонемента. Минуты - тип абонемента для предоставления бесплатных минут аренды на установленный период действия абонемента. Поездки - тип абонементам для предоставления бесплатных поездок на установленный период действия.',
  'Depending on the selected role, the user selection will be displayed':
    'В зависимости от выбранной роли отобразиться выбор пользователя',
  'Depending on the role of the user in the system there are different functionalities. You can find detailed information about the differencies in user roles you can find in our documentation':
    'В зависимости от роли пользователя доступны различные функциональные возможности в системе. С подробной информацией о функциональных особенностях каждой из доступных ролей можно ознакомиться в нашей документации',
  'Depending on the selected role of the account owner, a list of users of the corresponding role will be available.':
    'В зависимости от выбранной роли владельца учетной записи будет доступен список пользователей соответствующей роли.',
  'Depending on the assignment type, different document types are available. The "General" document type is a link to a legal document posted on the project website. The "Rental Agreement" is also a general document type; however, depending on the business model, this document can be used in different places, so it has been designated as a separate type. The "Acceptance Certificate" and "Power of Attorney" document types are generated based on an added document template, automatically populating the client and rented unit details.': 'В зависимости от типа назначения доступны различные типы документов. «Общий» тип документа представляет собой ссылку на правовой документ, размещенный на сайте проекта. «Договор аренды» также является документом общего типа, однако, в зависимости от бизнес-модели, данный документ может быть использован в разных местах, поэтому был выделен как отдельный тип. Типы документов «Акт приема-передачи» и «Доверенность» формируются на основании добавленного шаблона документа с автоматической подстановкой данных клиента и объекта аренды.',
  'Service hours': 'Время на уборку',
  'Date publish': 'Дата публикации',
  'Usages log': 'Журнал использований',
  'Activated at': 'Дата активации',
  'Minimum transaction amount': 'Минимальная сумма транзакции',
  'Card binding transaction amount': 'Сумма транзакции привязки карты',
  'Change of terms': 'Изменение условий',
  'Change quantity': 'Изменить количество',
  'Minimum transaction amount currency': 'Валюта минимальной суммы транзакции',
  Customer: 'Клиент',
  Custom: 'Пользовательский',
  'Don\'t show it again': 'Больше не показывать',
  'Reject publish': 'Отклонить публикацию квартиры',
  'Flat status': 'Статус квартиры',
  'Minimum rental period': 'Минимальный срок аренды',
  'Minimum number of satellites': 'Минимальное количество спутников',
  'Minimum altitude above sea level, m': 'Минимальная высота над уровнем моря, м',
  'Maximum altitude above sea level, m': 'Максимальная высота над уровнем моря, м',
  'altitude-region-hint': 'Для применения фильтрации невалидных координат по высоте, необходимо установить допустимый диапазон высоты над уровнем моря в регионе. Воспользуйтесь топографической картой местности для получения соответствующей информации. Фильтрация применяется только на онлайн сообщения для предотвращения выбросов и фиксации объекта на карте по последним валдиным координатам. В истории сообщений сохраняются фактические координаты, присланные оборудованием. Обращаем ваше внимание, что для применения фильтрации необходимо заполнить как минимальное, так и максимальное значения высоты, а объект должен быть назначен на регион вручную',
  Descriptions: 'Описания',
  Discounts: 'Скидки',
  'Increased tariff': 'Повышенные тариф',
  'Insurance balance': 'Баланс по страхованию',
  'Insurance report': 'Отчет по страхованию',
  'Insurance cancellation': 'Отмена страховки',
  'end-user-order-insurance-text': 'При отмене страховки осуществляется автоматический возврат денежных средств. Если страховка была оплачена по банковской карте, денежные средства будут возвращены на карту клиента. Если страховка была оплачена по балансу, операция списания денежных средств с баланса будет отменена. Партнерское вознаграждение, согласно установленным условиям, будет также отменено.',
  'Report format': 'Формат отчета',
  'Insurer type': 'Тип страховщика',
  'Illustration for mobile application': 'Иллюстрация для мобильного приложения',
  'Transfer to the balance': 'Начислять на баланс',
  'Percent value': 'Процент начисления',
  'Base URL': 'Базовый URL',
  'Insurance policy template (HTML)': 'Шаблон страхового полиса (HTML)',
  'Email for sending insurance reports': 'Email для отправки отчетов по страхованию',
  'Custom subject for insurance report messages': 'Кастомная тема сообщения для отправки отчетов по страхованию',
  Subject: 'Тема',
  'Sending interval': 'Периодичность отправки',
  Insurer: 'Страховщик',
  'Select insurer': 'Выберите страховщика',
  'If partner has its own contract with an insurance company, then you should select the previously created partner\'s insurer from the list. Otherwise, this field must be left blank.':
    'Если у партнера есть свой договор со страховой компанией, то необходимо выбрать ранее созданного страховщика партнера из списка. ' +
    'В противном случае, данное поле необходимо оставить незаполненным.',
  'If the income from insurance is distributed between the partner and the owner of the project / platform, then, depending on who accepts the payment for insurance, % of the insurance cost is either credited to the partner\'s balance or written-off. To specify the percentage value, select either "Add to balance" or "Withdraw from balance". If the insurance income is not distributed, select "NO".' :
    'Если доход от страховки распределяется между партнером и владельцем проекта / платформы, то, в зависимости от того, кто принимает платеж за страховку, % от стоимости страховки либо зачисляется на баланс партнера, либо списывается. Для указания значения процента необходимо выбрать либо "Зачислить на баланс", либо "Списать с баланса". Если же доход от страховки не распределяется, выберите НЕТ.',
  'If the news is intended to be displayed in all regions of the country, select the Country type. If the news can be displayed only in certain regions of the country, select the Regions type to be able to specify the required regions.' :
    'Если новость предназначена для отображения во всех регионах страны, выберите тип Страна. Если новость можно отображать только в отдельных регионах страны, для получения возможности указать необходимые регионы, выберите тип Регионы.',
  'If the news is intended to promote tourist routes or subscriptions, you can add buttons to go from the news article directly to the catalog of routes or subscriptions.' :
    'Если новость предназначения для продвижения туристических маршрутов или подписок, вы можете добавить кнопки перехода из новости непосредственно в каталог маршрутов или подписок соотвественно.',
  'It is necessary to specify the component type to create a component model. If the appropriate type is not listed you can create a new one on the Component Type Page.':
  'Для создания модели комплектующего необходимо указать тип комплектующего, которому соответствует создаваемая модель. Если в перечне нет соответствующего типа, создайте новый на странице Типы комплектующих.',
  'If a serial number is required for each component in this model, check this box. Components with serial numbers are added on the "Components" page. If components in this model do not have serial numbers, but only quantitative values, leave this field blank. Components without serial numbers are added on the "Components without s/n" page. Please note that this parameter cannot be changed once at least one component for this model has been added.':
  'Если для каждого комплектующего модели требуется указание серийного номера, необходимо поставить галочку в данном поле. Добавление комплектующих с серийными номерами осуществляется на странице «Комплектующие». Если комплектующие модели не имеют серийных номеров, а имеют лишь количественные показатели, оставьте данное поле пустым. Добавление комплектующих без серийных номеров осуществляется на странице «Комплектующие без с/н». Обращаем ваше внимание, что изменение данного параметра будет недоступно после добавления хотя бы одного комплектующего с данной моделью.',
  'If the component model only matches a specific model(s) of an unit, check this box and specify the unit type and model(s) in the "Assignments" section that appears. If the component model is not limited to specific unit models, leave this field blank. (Accessories, for example)':
    'Если модель комплектующего соответствует только определенной модели(-ям) объекта, необходимо поставить галочку в данном поле и, в появившемся блоке «Назначения» указать тип и модель(-и) объектов. Если модель комплектующего не ограничена определенными моделями, например, аксессуары, оставьте данное поле пустым.',
  'If the use of the service requires the client\'s consent to the terms of the document, check this point. If you simply want to add the document to the list of available legal documents in the mobile app, uncheck this box.': 'Если для использования сервиса необходимо согласие клиента с условиями документа, поставьте галочку в данном поле. Если вы хотите просто добавить документ в перечень доступных правовых документов в мобильном приложении, снимите галочку в данном поле.',
  'If a geofence has day of week or time restrictions, you can set the geofence\'s operating schedule by specifying the geofence\'s working days and/or working hours. Outside of business hours, the geofence\'s logic will not function, and the geofence will not be visible to clients in the mobile app.': 'Если на территории геозоны есть ограничения по дням недели или по времени, вы можете установить расписание работы геозоны, указав рабочие дни и/или рабочее время. Вне рабочего времени логика геозоны не будет работать, и геозона не будет отображаться клиентам в мобильном приложении.',
  'Percent of insurance amount': 'Процент от суммы страхования',
  'Percent of insurance amount to add to account': 'Процент от суммы страхования при зачислении на баланс',
  'Percent of insurance amount to withdraw from account': 'Процент от суммы страхования при списании с баланса',
  'Acquirer for insurance payments': 'Эквайер для платежей по страхованию',
  'Report log': 'Журнал отчетов',
  'Arbitrary report': 'Произвольный отчет',
  'Report interval': 'Интервал отчета',
  'Download report': 'Скачать отчет',
  'It will be displayed in the mobile application in the first line of the tariff preview of the tariff list.':
    'Будет отображаться в мобильном приложении в первой строчке превью тарифа списка тарифов. ',
  'It will be displayed in the mobile application on the second line of the tariff preview of the tariff list.':
    'Будет отображаться в мобильном приложении на второй строчке превью тарифа списка тарифов.',
  'It should be noted if you want the tariff to become available in the mobile application immediately after saving.':
    'Необходимо отметить, если вы хотите, чтобы тариф стал доступен в мобильном приложении сразу после сохранения.',
  'It should be noted if this rate is the cheapest default rate': 'Необходимо отметить, если данный тариф является самым дешевым тарифом по умолчанию',
  'It should be noted if you want to add a schedule for the availability of this tariff by time of day, days of the week, etc.':
    'Необходимо отметить, если вы хотите добавить расписание доступности данного тарифа по времени суток, дням недели и т.д.',
  'It is necessary to specify the language in which the information for the client is provided.':
    'Необходимо указать язык, на котором предоставляется информация для клиента',
  'It\'s on': 'Включена',
  'It\'s off': 'Выключена',
  'Rent type': 'Тип аренды',
  Reward: 'Вознаграждение',
  'Unavailable dates': 'Недоступные даты',
  Unavailable: 'Недоступен',
  'Cancellation cost': 'Стоимость отмены',
  'Free cancellation before (in hours)': 'Бесплатная отмена до (в часах)',
  'Free minutes': 'Бесплатные минуты',
  'Time for service (in hours)': 'Время на уборку (в часах)',
  'Price for service': 'Цена за уборку',
  'Collateral value': 'Залоговая стоимость',
  'Cancellation cost (percents from collateral value)': 'Стоимость отмены (в процентах от залоговой стоимости)',
  'Days of week': 'Дни недели',
  'Value (in percents)': 'Значение (в процентах)',
  'Discount from (in days)': 'Скидка от (в днях)',
  'Discount from (in hours)': 'Скидка от (в часах)',
  'Rent periods': 'Периоды бронирований',
  'Rent / Insurance': 'Аренда / Страховка',
  'Private key': 'Закрытый ключ',
  'Public Key (iOS)': 'Публичный ключ (iOS)',
  'Private Key (iOS)': 'Закрытый ключ (iOS)',
  'Captcha is active': 'Captcha активна',
  'Captcha public key': 'Captcha публичный ключ',
  'Captcha secret key': 'Captcha закрытый ключ',
  'Captcha IOS public key': 'Captcha IOS публичный ключ',
  'Captcha IOS secret key': 'Captcha IOS закрытый ключ',
  'Cashback percent': 'Процент кешбэка',
  'Cash register registration number': 'Регистрационный номер кассы',
  'Legal documents': 'Правовые документы',
  'Legal entities': 'Юридические лица',
  'Legal entity': 'Юр. лицо',
  'Less than 20% (hidden in the app)': 'Менее 20% (скрыто в приложении)',
  'Less than 20%': 'Менее 20%',
  'Level of demand': 'Уровень спроса',
  'Leave a comment in any format. This is an optional field. This field is used for administrative purposes only and is not used in the mobile app for clients.':
    'Оставьте комментарий в произвольной форме. Необязательное для заполнения поле. Используется только в административных целях и не отображается в мобильном приложении для клиентов.',
  'Client activity level': 'Уровень активности клиента',
  Level: 'Уровень',
  Leasing: 'Передача в аренду',
  'Leased out': 'Передано в аренду',
  'Country documents': 'Документы в стране',
  'Add country document': 'Добавить документ в стране',
  'Add a comment to this tariff. The comment is displayed only in the admin panel.':
    'Добавьте комментарий к данному тарифу. Комментарий отображается только в административной панели.',
  'Add a step': 'Добавить шаг',
  'Add option': 'Добавить вариант',
  Option: 'Вариант',
  'Add a question': 'Добавить вопрос',
  'Delete country document': 'Удалить документ в стране',
  Translates: 'Переводы',
  Link: 'Ссылка',
  'Link to detailed information': 'Ссылка на подробную информацию',
  'Link to the document': 'Ссылка на документ',
  'Link to the insurance company is terms and conditions page': 'Ссылка на страницу условий страхования страховой компании',
  'Text when accepting document': 'Текст при принятии документа',
  'Edit rent period': 'Изменить период бронирования',
  'Add rent period': 'Добавить период бронирования',
  'Time from': 'Время начала',
  'Time must be 3600 seconds or more': 'Время должно быть не менее 3600 секунд.',
  'Time must be 1800 seconds or more': 'Время должно быть не менее 1800 секунд.',
  'Time to': 'Время окончания',
  'Change booking': 'Изменить бронирование',
  'Make reservation': 'Создать бронирование',
  'make changes to the payment terms in the current billing period upon saving changes.':
    'внести изменение условий оплаты в текущем расчётном периоде по факту сохранения изменений.',
  'Type of property': 'Вид имущества',
  'Type of business model': 'Тип бизнес-модели',
  'View outside': 'Вид из окна',
  'Previous balance': 'Прежний баланс',
  'New balance': 'Новый баланс',
  'New (inactive)': 'Новые (неактивные)',
  'New (active)': 'Новые (активные)',
  'New messages from units': 'Новые сообщения от объектов',
  'New services': 'Новые заявки',
  'New ones first': 'Сначала новые',
  'Old ones first': 'Сначала старые',
  'Amount in coins': 'Сумма в монетах',
  'Purchase canceled': 'Покупка отменена',
  'Purchase region': 'Регион покупки',
  Purchase: 'Покупка',
  'Purchase finished': 'Покупка завершена',
  'Purchase status': 'Статус покупки',
  Pending: 'В обработке',
  'Unknown purchase status': 'Неизвестный статус покупки',
  'Cashback Percent': 'Процент кэшбэка',
  'Purchase time': 'Время покупки',
  'Purchase declined': 'Покупка отклонена',
  'Purpose of operation': 'Назначение операции',
  'Unit assignment': 'Назначение объекта',
  'Operation declined - insufficient funds': 'Операция отклонена - недостаточно средств',
  'Operation declined': 'Операция отклонена',
  'Payment number': 'Номер платежа',
  'Transaction ID': 'ID транзакции',
  'Error description': 'Описание ошибки',
  'Short description 1': 'Краткое описание 1',
  'Short description 2': 'Краткое описание 2',
  'Account number': 'Номер счета',
  'Finished by': 'Кем завершен',
  Finished_: 'Завершена',
  Server: 'Сервер',
  ORDER_FINISH_BY_USER: 'Пользователь {{user}}',
  'Contact type': 'Тип контакта',
  Contact: 'Контакт',
  'Contact information': 'Контактные данные',
  'Contact person': 'Контактное лицо',
  'Content language': 'Язык содержания',
  'HelpCrunch organisation': 'HelpCrunch organisation',
  'New HelpCrunch APP ID': 'Новый HelpCrunch APP ID',
  'New HelpCrunch secret': 'Новый HelpCrunch secret',
  'HelpCrunch APP ID': 'HelpCrunch APP ID',
  'HelpCrunch secret': 'HelpCrunch secret',
  'QRCode size': 'Размер регистрационного номера',
  'QR sharing': 'QR-шеринг',
  'Flash call balance': 'Баланс авторизационные звонки',
  'Debt by trips': 'Задолженность по поездкам',
  'Debt by penalties': 'Задолженность по штрафам',
  Declined: 'Отклонена',
  'Login for payments by binding': 'Логин для платежей по связке',
  'Password for payments by binding': 'Пароль для платежей по связке',
  'w.': 'н.',
  'Work shifts': 'Рабочие смены',
  'Working days': 'Рабочие дни',
  Cashback: 'Кешбэк',
  'Fiscalization service API login': 'логин API сервиса фискализации',
  'Fiscalization service API password': 'пароль API сервиса фискализации',
  'Success probability percent': 'Процент вероятности успеха',
  'Bank card first six digits (leave blank for random)': 'Первые 6 цифр банковской карты (оставьте пустым для случайного генерирования)',
  'Bank card last four digits (leave blank for random)': 'Последние 4 цифры банковской карты (оставьте пустым для случайного генерирования)',
  'Bank card type (leave blank for random)': 'Тип банковской карты (оставьте пустым для случайного генерирования)',
  'Bank card expiration time (MM/YY format, leave blank for random)': 'Срок действия банковской карты (формат ММ/ГГ, оставьте пустым для случайного генерирования)',
  'Transit account acquirer': 'Эквайер транзитного счета',
  'Transit account': 'Транзитный счет',
  'Transfer to partner\'s account' : 'Перевод на счет партнера',
  'Default commission percent': 'Процент комиссии по умолчанию',
  'Default map': 'Карта по умолчанию',
  'Refund transaction': 'Вернуть средства',
  'Are sure you want to refund this transaction': 'Вы действительно желаете вернуть средства',
  'Are you sure you want to cancel your subscription purchase and get a refund?':
    'Вы действительно желаете отменить покупку абонемента и вернуть средства?',
  'Are you sure you want to export table data?': 'Вы уверены, что хотите выполнить экспорт данных таблицы?',
  'Are you sure you want to end the courier\'s work shift?': 'Вы уверены, что хотите завершить рабочую смену курьера?',
  'Are you sure you want to remove the courier from the group?': 'Вы уверены, что хотите удалить курьера из группы?',
  'Transaction was successfully refunded': 'Возврат средств успешно произведен',
  'Error of transaction refund': 'Не удалось выполнить возврат средств',
  'Unknown bank card type': 'Неизвестный тип банковской карты',
  Acquiring: 'Эквайринг',
  'Acquiring for balance replenishment': 'Эквайринг пополнения баланса',
  'Acquiring payment acceptance': 'Эквайринг приема платежей',
  'This field is used only when migrating from one acquirer to another.': 'Это поле используется только при миграции с одного эквайера на другой.',
  'This field is for reference purposes only. It is recommended to include specific characteristics and features of the hardware model as a description.': 'Данное поле носит справочную информацию. Рекомендуется в качестве описания указывать специфические характеристики модели оборудования и её особенности.',
  'Next acquirer for insurance payments': 'Следующий эквайер для платежей по страхованию',
  'Insurance payment type': 'Тип платежа за страховку',
  'Next acquirer': 'Следующий эквайер',
  'Subscription fee merchant': 'Мерчант абон. платы',
  'Replenish balance': 'Пополнить баланс',
  'Top-up balance': 'Пополнить баланс',
  'Top-up amount': 'Сумма пополнения',
  'Amount to be withdrawn from card': 'Будет списано с карты',
  Proceed: 'Продолжить',
  'Payment settings': 'Настройки платежа',
  'Amount in your currency': 'Сумма в валюте вашего пользователя',
  'Amount in currency of payment system': 'Сумма в валюте платежной системы',
  'Replenish your balance with': 'Пополняйте свой баланс при помощи',
  Continue: 'Продолжить',
  'Payment amount must be greater': 'Сумма платежа должна быть больше',
  'Maximum allowable amount has been exceeded': 'Превышена малсимально допустимая сумма',
  'Replenish balance balance failed': 'Не удалось пополнить баланс',
  'Replenish balance was canceled': 'Пополнение баланса отменено',
  'Replenish balance was declined': 'Пополнение баланса отклонено',
  'Replenish balance successfully completed': 'Баланс успешно пополнен',
  'Account balance successfully replenished': 'Баланс успешно пополнен',
  REPLENISH_USER_BALANCE_ERROR_MESSAGE:
    'Услуга для пополнения баланса с помощью платежной системы {{paymentSystem}} не доступна. Пожалуйста, обратитесь в службу тех. поддержки.',
  Icon: 'Иконка',
  'Icon Library': 'Библиотека иконок',
  'Image height is too large': 'Слишком большая высота картинки',
  'Image width is too large': 'Слишком большая ширина картинки',
  'Image size is too large': 'Слишком большой размер картинки(Макс. размер 15 килобайт)',
  'Telegram Chat ID': 'Идентификатор чата Telegram',
  'Telegram bot api key': 'API-ключ телеграм-бота',
  'Telegram account': 'Аккаунт Telegram',
  'Telegram Group': 'Группа телеграм',
  'Send message to telegram': 'Отправить сообщение в telegram',
  'Max. count of bookings (0 - no limits)': 'Максимальное количество бронирований (0 - без ограничений)',
  'Image format must be SVG or PNG': 'Формат изображения должен быть SVG или PNG',
  'Image format must be SVG': 'Формат изображения должен быть SVG',
  Detailing: 'Детализация',
  'Averages-statistic': 'Средняя длительность состояния активных объектов в указанный период',
  'Object-statistic-description': 'Объекты, которые переводили в статус Доступен в указанный период',
  'Object models': 'Модели объектов',
  'Balance-statistic': 'Балансовые',
  'Refunds(balance)': 'Возвраты(балансовые)',
  Refunded: 'Возвращена',
  'Refund amount': 'Сумма возврата',
  'Related operations': 'Связанные операции',
  'Cancellation of debt': 'Отмена задолженности',
  'coming soon': 'скоро',
  'Assigned to regions': 'Назначен на регионы',
  'All regions': 'Все регионы',
  'All users': 'Все пользователи',
  'All user objects': 'Все объекты пользователя',
  'All couriers': 'Все курьеры',
  'My couriers': 'Мои курьеры',
  'Advanced holding settings': 'Расширенные настройки холдирования',
  'Holding confirmation': 'Подтверждение холдирования',
  'Mandatory card binding': 'Обязательная привязка карты',
  'Card binding': 'Привязка карты',
  'For new clients': 'Для новых клиентов',
  'Tariffs with this option will be available to clients without finished orders in place of regular tariffs': 'Такие тарифы будут предлагаться новым клиентам (у кого нет успешных заказов) вместо базовых тарифов',
  day_: 'дня',
  days: 'дней',
  year: 'год',
  years: 'года',
  years_: 'лет',
  pcs: 'шт',
  'osm-hint': 'Бесплатная карта мира. Используется в системе по умолчанию. Подключается без API ключа',
  'gomap-hint': 'Бесплатная национальная карта Азербайджана. Подключается без API ключа',
  'google-maps-hint': 'Официальные карты Google Platform. Необходим ключ API, полученный на сайте сервиса <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-maps-api-key-hint': 'Введите ключ API, полученный на сайте сервиса <a href="https://mapsplatform.google.com/" target="_blank">https://mapsplatform.google.com/</a>',
  'google-roadmap-hint': 'Режим отображения, представляющий собой классическую схематическую карту улиц и дорог',
  'google-hybrid-hint': 'Режим отображения, объединяющий спутниковые снимки с наложенной поверх них схемой дорог, улиц и названий объектов',
  'default-map-hint': 'Выберите карту, которая будет отображаться вам и другим вашим пользователям по умолчанию',
  'Are you sure you want to manually confirm the client\'s email?': 'Вы уверены, что хотите вручную подтвердить email клиента?',
  findOrdersPlaceholder: 'Воспользуйтесь инструментами карты, чтобы указать область поиска. Выберите период времени и нажмите "Поиск"',
  'Number of selected objects': 'Количество выбранных объектов',
  'Command source': 'Источник команды',
  'Select command source': 'Выберите источник команды',
  'Command template': 'Шаблон команды',
  'Payment by card': 'Оплата по карте',
  'Payment by balance': 'Оплата по балансу',
  Compensation: 'Компенсация',
  'Balance adjustment': 'Корректировка баланса',
  'Receipts to the client balance': 'Поступления на баланс клиента',
  'Bonus parking': 'Бонусная парковка',
  'Paid by card': 'Оплачено по карте',
  'Paid by balance': 'Оплачено по балансу',
  'Paid via payment services': 'Платежные сервисы',
  'Custom period': 'Произвольный период',
  'Only my units': 'Только мои объекты'
};
